import {toRem} from 'shared/helpers';
import {COLORS, GRAYSCALE_91_COLOR, GRAYSCALE_96_COLOR, ORANGE_COLOR_RGB} from './colors';

export const SCREEN_ESM = 480;
export const SCREEN_SM = 576;
export const SCREEN_MD = 768;
export const SCREEN_LG = 992;
export const SCREEN_XL = 1200;
export const SCREEN_XXL = 1400;
export const SCREEN_FHD = 1920;

export const ATOMARO_VARIABLE_STYLES = `
  --body-bg: light-dark(${GRAYSCALE_96_COLOR}, ${GRAYSCALE_96_COLOR});
  --base-accent: light-dark(${COLORS.ACCENT.DEFAULT}, ${COLORS.ACCENT.DEFAULT});
  --button-ghost-accent-label-color-default: light-dark(${COLORS.FG.DEFAULT}, ${COLORS.FG.DEFAULT});
  --button-ghost-accent-bg-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.1);
  --focus-contrast: rgba(${ORANGE_COLOR_RGB}, 0.1);
  --button-ghost-accent-bg-color-active: rgba(${ORANGE_COLOR_RGB}, 0.2);
  --button-ghost-accent-label-color-hover: var(--button-ghost-accent-label-color-default);
  --button-ghost-accent-label-color-active: var(--button-ghost-accent-label-color-default);
  --font-family: "Rostelecom Basis", Arial, Helvetica, sans-serif;

  
  --base-neutral: #999999;
  --base-accent: ${COLORS.ACCENT.DEFAULT};
  --base-success: #019F3C;
  --base-warning: #F29100;
  --base-error: #D91528;
  --base-info: #1998FF;
  --base-status-01: #00B288;
  --base-status-02: #1192BB;
  --base-status-03: #6952F5;
  --base-status-04: #9924FF;
  --base-status-05: #E33A82;
  --base-status-06: #FA5300;
  --neutral-1000: #000;
  --neutral-990: ${COLORS.FG.DEFAULT};
  --neutral-950: #181d28;
  --neutral-925: #1d2431;
  --neutral-900: #222a39;
  --neutral-800: #293244;
  --neutral-700: #303a4f;
  --neutral-600: #3a4760;
  --neutral-500: #999999;
  --neutral-400: #69758d;
  --neutral-300: #858fa3;
  --neutral-200: #a2a9b8;
  --neutral-100: #d0d4dc;
  --neutral-50: #eceef1;
  --neutral-25: #f6f6f8;
  --neutral-10: #f9fafb;
  --neutral-0: #fff;
  --accent-1000: #000;
  --accent-990: #013;
  --accent-950: #001e59;
  --accent-925: #00256e;
  --accent-900: #002b80;
  --accent-800: #039;
  --accent-700: ${COLORS.ACCENT.DEFAULT};
  --accent-600: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --accent-500: ${COLORS.ACCENT.DEFAULT};
  --accent-400: ${COLORS.ACCENT.DEFAULT};
  --accent-300: #5991ff;
  --accent-200: #80aaff;
  --accent-100: #bfd4ff;
  --accent-50: #e6eeff;
  --accent-25: #f2f7ff;
  --accent-10: #f7faff;
  --accent-0: #fff;
  --success-1000: #000;
  --success-990: #00200c;
  --success-950: #003815;
  --success-925: #00441a;
  --success-900: #01501e;
  --success-800: #015f24;
  --success-700: #016f2a;
  --success-600: #018733;
  --success-500: #019F3C;
  --success-400: #34b263;
  --success-300: #5ac180;
  --success-200: #80cf9e;
  --success-100: #c0e7ce;
  --success-50: #e6f5ec;
  --success-25: #f2faf5;
  --success-10: #f7fcf9;
  --success-0: #fff;
  --warning-1000: #000;
  --warning-990: #301d00;
  --warning-950: #530;
  --warning-925: #683e00;
  --warning-900: #794900;
  --warning-800: #915700;
  --warning-700: #a96600;
  --warning-600: #ce7b00;
  --warning-500: #F29100;
  --warning-400: #f5a733;
  --warning-300: #f7b859;
  --warning-200: #f9c880;
  --warning-100: #fce3bf;
  --warning-50: #fef4e6;
  --warning-25: #fefaf2;
  --warning-10: #fffcf7;
  --warning-0: #fff;
  --error-1000: #000;
  --error-990: #2b0408;
  --error-950: #4c070e;
  --error-925: #5d0911;
  --error-900: #6d0b14;
  --error-800: #820d18;
  --error-700: #980f1c;
  --error-600: #b81222;
  --error-500: #D91528;
  --error-400: #e14453;
  --error-300: #e66773;
  --error-200: #ec8a93;
  --error-100: #f6c5c9;
  --error-50: #fbe8ea;
  --error-25: #fdf3f4;
  --error-10: #fef8f9;
  --error-0: #fff;
  --info-1000: #000;
  --info-990: #051e33;
  --info-950: #093559;
  --info-925: #0b416e;
  --info-900: #0d4c80;
  --info-800: #0f5b99;
  --info-700: #126ab3;
  --info-600: #1581d9;
  --info-500: #1998FF;
  --info-400: #47adff;
  --info-300: #6abcff;
  --info-200: #8cccff;
  --info-100: #c6e5ff;
  --info-50: #e8f5ff;
  --info-25: #f3faff;
  --info-10: #f8fcff;
  --info-0: #fff;
  --status-01-1000: #000;
  --status-01-990: #00241b;
  --status-01-950: #003e30;
  --status-01-925: #004d3a;
  --status-01-900: #005944;
  --status-01-800: #006b52;
  --status-01-700: #007d5f;
  --status-01-600: #009774;
  --status-01-500: #00B288;
  --status-01-400: #33c1a0;
  --status-01-300: #59cdb2;
  --status-01-200: #80d9c3;
  --status-01-100: #bfece1;
  --status-01-50: #e6f7f3;
  --status-01-25: #f2fbf9;
  --status-01-10: #f7fdfb;
  --status-01-0: #fff;
  --status-02-1000: #000;
  --status-02-990: #031d25;
  --status-02-950: #063341;
  --status-02-925: #073f50;
  --status-02-900: #09495e;
  --status-02-800: #0a5870;
  --status-02-700: #0c6683;
  --status-02-600: #0e7c9f;
  --status-02-500: #1192BB;
  --status-02-400: #41a8c9;
  --status-02-300: #64b8d3;
  --status-02-200: #88c9dd;
  --status-02-100: #c3e4ee;
  --status-02-50: #e7f4f8;
  --status-02-25: #f3fafc;
  --status-02-10: #f8fcfd;
  --status-02-0: #fff;
  --status-03-1000: #000;
  --status-03-990: #151031;
  --status-03-950: #251d56;
  --status-03-925: #2d2369;
  --status-03-900: #35297b;
  --status-03-800: #3f3193;
  --status-03-700: #4a39ac;
  --status-03-600: #5946d0;
  --status-03-500: #6952F5;
  --status-03-400: #8775f7;
  --status-03-300: #9e8ff9;
  --status-03-200: #b4a9fa;
  --status-03-100: #dad4fd;
  --status-03-50: #f0eefe;
  --status-03-25: #f8f6ff;
  --status-03-10: #fbfaff;
  --status-03-0: #fff;
  --status-04-1000: #000;
  --status-04-990: #1f0733;
  --status-04-950: #360d59;
  --status-04-925: #420f6e;
  --status-04-900: #4d1280;
  --status-04-800: #5c1699;
  --status-04-700: #6b19b3;
  --status-04-600: #821fd9;
  --status-04-500: #9924FF;
  --status-04-400: #ad50ff;
  --status-04-300: #bd71ff;
  --status-04-200: #cc92ff;
  --status-04-100: #e6c8ff;
  --status-04-50: #f5e9ff;
  --status-04-25: #faf4ff;
  --status-04-10: #fcf8ff;
  --status-04-0: #fff;
  --status-05-1000: #000;
  --status-05-990: #2d0c1a;
  --status-05-950: #4f142d;
  --status-05-925: #621938;
  --status-05-900: #721d41;
  --status-05-800: #88234e;
  --status-05-700: #9f295b;
  --status-05-600: #c1316e;
  --status-05-500: #E33A82;
  --status-05-400: #e9619b;
  --status-05-300: #ed7fae;
  --status-05-200: #f19dc1;
  --status-05-100: #f8cee0;
  --status-05-50: #fcebf3;
  --status-05-25: #fef5f9;
  --status-05-10: #fef9fb;
  --status-05-0: #fff;
  --status-06-1000: #000;
  --status-06-990: #321100;
  --status-06-950: #581d00;
  --status-06-925: #6c2400;
  --status-06-900: #7d2a00;
  --status-06-800: #963200;
  --status-06-700: #af3a00;
  --status-06-600: #d44700;
  --status-06-500: #FA5300;
  --status-06-400: #fb7533;
  --status-06-300: #fc8f59;
  --status-06-200: #fda980;
  --status-06-100: #fed4bf;
  --status-06-50: #ffeee6;
  --status-06-25: #fff6f2;
  --status-06-10: #fffaf7;
  --status-06-0: #fff;
  --font-family-base: var(--font-family);
  --font-family-display: var(--font-family);
  --font-family-heading: var(--font-family);
  --font-family-body: var(--font-family);
  --font-family-description: var(--font-family);
  --font-weight-bold: 800;
  --font-weight-semibold: 600;
  --font-weight-regular: 400;
  --font-size-base: 16px;
  --font-line-height-base: 16px;
  --font-display-l: 600 48px/52px var(--font-family);
  --font-display-l-strong: 800 48px/52px var(--font-family);
  --font-display-m: 600 42px/44px var(--font-family);
  --font-display-m-strong: 800 42px/44px var(--font-family);
  --font-display-s: 600 32px/44px var(--font-family);
  --font-display-s-strong: 800 32px/44px var(--font-family);
  --font-heading-h1: 800 28px/32px var(--font-family);
  --font-heading-h2: 800 22px/24px var(--font-family);
  --font-heading-h3: 800 18px/20px var(--font-family);
  --font-heading-h4: 800 16px/20px var(--font-family);
  --font-heading-h5: 800 14px/20px var(--font-family);
  --font-body-l: 400 18px/26px var(--font-family);
  --font-body-l-strong: 600 18px/26px var(--font-family);
  --font-body-m: 400 16px/24px var(--font-family);
  --font-body-m-strong: 600 16px/24px var(--font-family);
  --font-body-s: 400 14px/20px var(--font-family);
  --font-body-s-strong: 600 14px/20px var(--font-family);
  --font-description-l: 400 12px/16px var(--font-family);
  --font-description-l-strong: 600 12px/16px var(--font-family);
  --font-description-m: 400 11.008px/16px var(--font-family);
  --font-description-m-strong: 600 11.008px/16px var(--font-family);
  --font-description-s: 400 10px/12px var(--font-family);
  --font-description-s-strong: 600 10px/12px var(--font-family);
  --border-radius-base: 6px;
  --border-radius-none: 0;
  --border-radius-full: 9999px;
  --border-radius-2xs: 2px;
  --border-radius-xs: 3px;
  --border-radius-s: 4px;
  --border-radius-m: 6px;
  --border-radius-l: 9px;
  --border-radius-xl: 12px;
  --border-radius-2xl: 24px;
  --border-radius-inputs: 6px;
  --border-radius-buttons: 6px;
  --border-radius-controls: 3px;
  --spacing-base: 16px;
  --spacing-none: 0;
  --spacing-px: 1px;
  --spacing-0-5x: 2px;
  --spacing-1x: 4px;
  --spacing-1-5x: 6px;
  --spacing-2x: 8px;
  --spacing-3x: 12px;
  --spacing-4x: 16px;
  --spacing-5x: 20px;
  --spacing-6x: 24px;
  --spacing-8x: 32px;
  --spacing-10x: 40px;
  --spacing-12x: 48px;
  --spacing-16x: 64px;
  --spacing-20x: 80px;
  --spacing-24x: 96px;
  --spacing-32x: 128px;
  --spacing-48x: 192px;
  --size-base: 16px;
  --size-xl: 56px;
  --size-l: 48px;
  --size-m: 36px;
  --size-m-chip: 32px;
  --size-m-tag: 28px;
  --size-s: 24px;
  --size-xs: 20px;
  --size-2xs: 16px;
  --none: rgba(255,255,255,0);
  --shadow-none: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --shadow-bottom-s: 0 0 8px 0 rgba(153, 153, 153, 0.1), 0 2px 4px 0 rgba(153, 153, 153, 0.05);
  --shadow-bottom-m: 0 0 16px 0 rgba(153, 153, 153, 0.1), 0 4px 8px 0 rgba(153, 153, 153, 0.05);
  --shadow-bottom-l: 0 0 20px 0 rgba(153, 153, 153, 0.1), 0 12px 20px 0 rgba(153, 153, 153, 0.05);
  --shadow-bottom-xl: 0 0 32px 0 rgba(153, 153, 153, 0.1), 0 32px 32px 0 rgba(153, 153, 153, 0.05);
  --shadow-bottom-controls: 0 0 1px 0 rgba(153, 153, 153, 0.1), 0 2px 2px 0 rgba(153, 153, 153, 0.2);
  --shadow-bottom-accent-s: 0 2px 4px 0 rgba(${ORANGE_COLOR_RGB}, 0.1), 0 0 8px 0 rgba(${ORANGE_COLOR_RGB}, 0.05);
  --shadow-bottom-accent-m: 0 4px 8px 0 rgba(${ORANGE_COLOR_RGB}, 0.1), 0 0 16px 0 rgba(${ORANGE_COLOR_RGB}, 0.05);
  --shadow-bottom-accent-l: 0 12px 20px 0 rgba(${ORANGE_COLOR_RGB}, 0.1), 0 0 20px 0 rgba(${ORANGE_COLOR_RGB}, 0.05);
  --shadow-bottom-accent-xl: 0 32px 32px 0 rgba(${ORANGE_COLOR_RGB}, 0.1), 0 0 32px 0 rgba(${ORANGE_COLOR_RGB}, 0.05);
  --shadow-bottom-accent-controls: 0 2px 2px 0 rgba(${ORANGE_COLOR_RGB}, 0.1), 0 0 1px 0 rgba(${ORANGE_COLOR_RGB}, 0.2);
  --shadow-top-s: 0 0 8px 0 rgba(153, 153, 153, 0.1), 0 -2px 4px 0 rgba(153, 153, 153, 0.05);
  --shadow-top-m: 0 0 16px 0 rgba(153, 153, 153, 0.1), 0 -4px 8px 0 rgba(153, 153, 153, 0.05);
  --shadow-top-l: 0 0 20px 0 rgba(153, 153, 153, 0.1), 0 -12px 20px 0 rgba(153, 153, 153, 0.05);
  --shadow-top-xl: 0 0 32px 0 rgba(153, 153, 153, 0.1), 0 -32px 32px 0 rgba(153, 153, 153, 0.05);
  --shadow-top-controls: 0 0 1px 0 rgba(153, 153, 153, 0.1), 0 -2px 2px 0 rgba(153, 153, 153, 0.2);
  --motion-duration-2xs: 100ms;
  --motion-duration-xs: 150ms;
  --motion-duration-s: 200ms;
  --motion-duration-m: 300ms;
  --motion-duration-l: 600ms;
  --motion-duration-xl: 1200ms;
  --motion-easing-linear: cubic-bezier(0, 0, 1, 1);
  --motion-easing-productive-standard: cubic-bezier(0.4, 0, 0.6, 1);
  --motion-easing-productive-entrance: cubic-bezier(0, 0, 0.6, 1);
  --motion-easing-productive-exit: cubic-bezier(0.3, 0, 1, 0.9);
  --motion-easing-productive-bouncing: cubic-bezier(0.18, 0.89, 0.35, 1.15);
  --motion-easing-expressive-standard: cubic-bezier(0.8, 0, 0.2, 1);
  --motion-easing-expressive-entrance: cubic-bezier(0, 0, 0.3, 1);
  --motion-easing-expressive-exit: cubic-bezier(0.8, 0.15, 1, 1);
  --motion-easing-expressive-bouncing: cubic-bezier(0.7, 0.3, 0.5, 1.25);
  --mobile-font-display-l: 600 28px/36px var(--font-family);
  --mobile-font-display-l-strong: 800 28px/36px var(--font-family);
  --mobile-font-display-m: 600 24px/32px var(--font-family);
  --mobile-font-display-m-strong: 800 24px/32px var(--font-family);
  --mobile-font-display-s: 600 20px/28px var(--font-family);
  --mobile-font-display-s-strong: 800 20px/28px var(--font-family);
  --mobile-font-heading-h1: 800 18px/24px var(--font-family);
  --mobile-font-heading-h2: 800 16px/20px var(--font-family);
  --mobile-font-heading-h3: 800 15.008px/20px var(--font-family);
  --mobile-font-heading-h4: 800 14px/20px var(--font-family);
  --mobile-font-heading-h5: 800 13.008px/20px var(--font-family);
  --mobile-font-body-l: 400 15.008px/20px var(--font-family);
  --mobile-font-body-l-strong: 600 15.008px/20px var(--font-family);
  --mobile-font-body-m: 400 14px/20px var(--font-family);
  --mobile-font-body-m-strong: 600 14px/20px var(--font-family);
  --mobile-font-body-s: 400 13.008px/20px var(--font-family);
  --mobile-font-body-s-strong: 600 13.008px/20px var(--font-family);
  --mobile-font-description-l: 400 12px/16px var(--font-family);
  --mobile-font-description-l-strong: 600 12px/16px var(--font-family);
  --mobile-font-description-m: 400 11.008px/16px var(--font-family);
  --mobile-font-description-m-strong: 600 11.008px/16px var(--font-family);
  --mobile-font-description-s: 400 10px/12px var(--font-family);
  --mobile-font-description-s-strong: 600 10px/12px var(--font-family);
  --border-width-none: 0;
  --border-width-s: 1px;
  --border-width-m: 2px;
  --border-width-l: 4px;
  --border-width-inputs: 2px;
  --border-width-buttons: 2px;
  --border-width-controls: 2px;
  --border-width-dividers: 1px;
  --breakpoint-2xs: 0;
  --breakpoint-xs: 480;
  --breakpoint-s: 768;
  --breakpoint-m: 1024;
  --breakpoint-l: 1280;
  --breakpoint-xl: 1600;
  --z-index-hide: -1;
  --z-index-default: 0;
  --z-index-dropdown: 1000;
  --z-index-sticky: 1100;
  --z-index-fab: 1200;
  --z-index-overlay: 1300;
  --z-index-loader: 1400;
  --z-index-modal: 1500;
  --z-index-toast: 1600;
  --z-index-popover: 1700;
  --z-index-tooltip: 1800;
  --fg-default: ${COLORS.FG.DEFAULT};
  --fg-soft: ${COLORS.FG.SOFT};
  --fg-muted: ${COLORS.FG.MUTED};
  --fg-disabled: ${COLORS.FG.DISABLED};
  --bg-surface1: ${COLORS.BG.SURFACE1};
  --bg-surface2: ${COLORS.BG.SURFACE2};
  --bg-surface3: ${COLORS.BG.SURFACE3};
  --bg-surface4: ${COLORS.BG.SURFACE4};
  --bg-surface5: ${COLORS.BG.SURFACE5};
  --bg-page: ${COLORS.BG.PAGE};
  --bg-disabled: ${COLORS.BG.DISABLED};
  --bg-elevated-0: ${COLORS.BG.ELEVATED.ZERO};
  --bg-elevated-s: ${COLORS.BG.ELEVATED.S};
  --bg-elevated-m: ${COLORS.BG.ELEVATED.M};
  --bg-elevated-l: ${COLORS.BG.ELEVATED.L};
  --bg-elevated-xl: ${COLORS.BG.ELEVATED.XL};
  --border-default: ${COLORS.BORDER.DEFAULT};
  --border-soft: ${COLORS.BORDER.SOFT};
  --border-muted: ${COLORS.BORDER.MUTED};
  --accent-default: ${COLORS.ACCENT.DEFAULT};
  --accent-soft: ${COLORS.ACCENT.DEFAULT};
  --accent-muted: #FFA789;
  --accent-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --accent-active: ${COLORS.ACCENT.DEFAULT};
  --accent-on-accent: #fff;
  --accent-container-default: rgba(${ORANGE_COLOR_RGB}, 0.1);
  --accent-container-soft: rgba(${ORANGE_COLOR_RGB}, 0.05);
  --accent-container-muted: rgba(${ORANGE_COLOR_RGB}, 0.03);
  --accent-container-hover: rgba(${ORANGE_COLOR_RGB}, 0.2);
  --accent-container-active: rgba(${ORANGE_COLOR_RGB}, 0.3);
  --accent-on-container: ${COLORS.ACCENT.DEFAULT};
  --neutral-default: #999999;
  --neutral-soft: #69758d;
  --neutral-muted: #a2a9b8;
  --neutral-hover: #3a4760;
  --neutral-active: #303a4f;
  --neutral-on-neutral: #fff;
  --neutral-container-default: rgba(153, 153, 153, 0.1);
  --neutral-container-soft: ${COLORS.NEUTRAL.CONTAINER_SOFT};
  --neutral-container-muted: rgba(153, 153, 153, 0.03);
  --neutral-container-hover: rgba(153, 153, 153, 0.2);
  --neutral-container-active: rgba(153, 153, 153, 0.3);
  --neutral-on-container: #999999;
  --success-default: #019F3C;
  --success-soft: #34b263;
  --success-muted: #80cf9e;
  --success-hover: #018733;
  --success-active: #016f2a;
  --success-on-success: #fff;
  --success-container-default: rgba(1, 159, 60, 0.1);
  --success-container-soft: rgba(1, 159, 60, 0.05);
  --success-container-muted: rgba(1, 159, 60, 0.03);
  --success-container-hover: rgba(1, 159, 60, 0.2);
  --success-container-active: rgba(1, 159, 60, 0.3);
  --success-on-container: #019F3C;
  --warning-default: #F29100;
  --warning-soft: #f5a733;
  --warning-muted: #f9c880;
  --warning-hover: #ce7b00;
  --warning-active: #a96600;
  --warning-on-warning: #301d00;
  --warning-container-default: rgba(242, 145, 0, 0.1);
  --warning-container-soft: rgba(242, 145, 0, 0.05);
  --warning-container-muted: rgba(242, 145, 0, 0.03);
  --warning-container-hover: rgba(242, 145, 0, 0.2);
  --warning-container-active: rgba(242, 145, 0, 0.3);
  --warning-on-container: #ce7b00;
  --error-default: #D91528;
  --error-soft: #e14453;
  --error-muted: #ec8a93;
  --error-hover: #b81222;
  --error-active: #980f1c;
  --error-on-error: #fff;
  --error-container-default: rgba(217, 21, 40, 0.1);
  --error-container-soft: rgba(217, 21, 40, 0.05);
  --error-container-muted: rgba(217, 21, 40, 0.03);
  --error-container-hover: rgba(217, 21, 40, 0.2);
  --error-container-active: rgba(217, 21, 40, 0.3);
  --error-on-container: #D91528;
  --info-default: #1998FF;
  --info-soft: #47adff;
  --info-muted: #8cccff;
  --info-hover: #1581d9;
  --info-active: #126ab3;
  --info-on-info: #fff;
  --info-container-default: rgba(25, 152, 255, 0.1);
  --info-container-soft: rgba(25, 152, 255, 0.05);
  --info-container-muted: rgba(25, 152, 255, 0.03);
  --info-container-hover: rgba(25, 152, 255, 0.2);
  --info-container-active: rgba(25, 152, 255, 0.3);
  --info-on-container: #1998FF;
  --status-01-default: #00B288;
  --status-01-soft: #33c1a0;
  --status-01-muted: #80d9c3;
  --status-01-hover: #009774;
  --status-01-active: #007d5f;
  --status-01-on-status-01: #fff;
  --status-01-container-default: rgba(0, 178, 136, 0.1);
  --status-01-container-soft: rgba(0, 178, 136, 0.05);
  --status-01-container-muted: rgba(0, 178, 136, 0.03);
  --status-01-container-hover: rgba(0, 178, 136, 0.2);
  --status-01-container-active: rgba(0, 178, 136, 0.3);
  --status-01-on-container: #00B288;
  --status-02-default: #1192BB;
  --status-02-soft: #41a8c9;
  --status-02-muted: #88c9dd;
  --status-02-hover: #0e7c9f;
  --status-02-active: #0c6683;
  --status-02-on-status-02: #fff;
  --status-02-container-default: rgba(17, 146, 187, 0.1);
  --status-02-container-soft: rgba(17, 146, 187, 0.05);
  --status-02-container-muted: rgba(17, 146, 187, 0.03);
  --status-02-container-hover: rgba(17, 146, 187, 0.2);
  --status-02-container-active: rgba(17, 146, 187, 0.3);
  --status-02-on-container: #1192BB;
  --status-03-default: #6952F5;
  --status-03-soft: #8775f7;
  --status-03-muted: #b4a9fa;
  --status-03-hover: #5946d0;
  --status-03-active: #4a39ac;
  --status-03-on-status-03: #fff;
  --status-03-container-default: rgba(105, 82, 245, 0.1);
  --status-03-container-soft: rgba(105, 82, 245, 0.05);
  --status-03-container-muted: rgba(105, 82, 245, 0.03);
  --status-03-container-hover: rgba(105, 82, 245, 0.2);
  --status-03-container-active: rgba(105, 82, 245, 0.3);
  --status-03-on-container: #6952F5;
  --status-04-default: #9924FF;
  --status-04-soft: #ad50ff;
  --status-04-muted: #cc92ff;
  --status-04-hover: #821fd9;
  --status-04-active: #6b19b3;
  --status-04-on-status-04: #fff;
  --status-04-container-default: rgba(153, 36, 255, 0.1);
  --status-04-container-soft: rgba(153, 36, 255, 0.05);
  --status-04-container-muted: rgba(153, 36, 255, 0.03);
  --status-04-container-hover: rgba(153, 36, 255, 0.2);
  --status-04-container-active: rgba(153, 36, 255, 0.3);
  --status-04-on-container: #9924FF;
  --status-05-default: #E33A82;
  --status-05-soft: #e9619b;
  --status-05-muted: #f19dc1;
  --status-05-hover: #c1316e;
  --status-05-active: #9f295b;
  --status-05-on-status-05: #fff;
  --status-05-container-default: rgba(227, 58, 130, 0.1);
  --status-05-container-soft: rgba(227, 58, 130, 0.05);
  --status-05-container-muted: rgba(227, 58, 130, 0.03);
  --status-05-container-hover: rgba(227, 58, 130, 0.2);
  --status-05-container-active: rgba(227, 58, 130, 0.3);
  --status-05-on-container: #E33A82;
  --status-06-default: #FA5300;
  --status-06-soft: #fb7533;
  --status-06-muted: #fda980;
  --status-06-hover: #d44700;
  --status-06-active: #af3a00;
  --status-06-on-status-06: #fff;
  --status-06-container-default: rgba(250, 83, 0, 0.1);
  --status-06-container-soft: rgba(250, 83, 0, 0.05);
  --status-06-container-muted: rgba(250, 83, 0, 0.03);
  --status-06-container-hover: rgba(250, 83, 0, 0.2);
  --status-06-container-active: rgba(250, 83, 0, 0.3);
  --status-06-on-container: #FA5300;
  --static-white: #fff;
  --static-black: ${COLORS.FG.DEFAULT};
  --focus-soft: rgba(${ORANGE_COLOR_RGB}, 0.1);
  --focus-contrast: rgba(${ORANGE_COLOR_RGB}, 0.1);
  --focus-extra: #fff;
  --checkbox-primary-bg-color-default: rgba(255,255,255,0);
  --checkbox-primary-bg-color-hover: rgba(255,255,255,0);
  --checkbox-primary-bg-color-disabled: rgba(153, 153, 153, 0.1);
  --checkbox-primary-bg-color-checked-default: ${COLORS.ACCENT.DEFAULT};
  --checkbox-primary-bg-color-checked-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --checkbox-primary-bg-color-checked-disabled: rgba(153, 153, 153, 0.1);
  --checkbox-primary-border-color-default: rgba(153, 153, 153, 0.25);
  --checkbox-primary-border-color-hover: ${COLORS.ACCENT.DEFAULT};
  --checkbox-primary-border-color-disabled: rgba(255,255,255,0);
  --checkbox-primary-border-color-checked-default: rgba(255,255,255,0);
  --checkbox-primary-border-color-checked-hover: rgba(255,255,255,0);
  --checkbox-primary-border-color-checked-disabled: rgba(255,255,255,0);
  --checkbox-primary-label-color-default: ${COLORS.FG.DEFAULT};
  --checkbox-primary-label-color-hover: ${COLORS.FG.DEFAULT};
  --checkbox-primary-label-color-disabled: rgba(153, 153, 153, 0.5);
  --checkbox-primary-label-color-checked-default: ${COLORS.FG.DEFAULT};
  --checkbox-primary-label-color-checked-hover: ${COLORS.FG.DEFAULT};
  --checkbox-primary-label-color-checked-disabled: rgba(153, 153, 153, 0.5);
  --checkbox-primary-icon-color-checked-default: #fff;
  --checkbox-primary-icon-color-checked-hover: #fff;
  --checkbox-primary-icon-color-checked-disabled: rgba(153, 153, 153, 0.5);
  --checkbox-primary-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --checkbox-primary-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --checkbox-primary-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --checkbox-primary-shadow-checked-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --checkbox-primary-shadow-checked-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --checkbox-primary-shadow-checked-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --checkbox-primary-frame-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --checkbox-primary-frame-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --checkbox-primary-frame-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --checkbox-primary-frame-shadow-checked-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --checkbox-primary-frame-shadow-checked-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --checkbox-primary-frame-shadow-checked-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --checkbox-s-font: 400 16px/24px var(--font-family);
  --checkbox-s-height: 24px;
  --checkbox-s-padding: 2px;
  --checkbox-s-spacing: 8px;
  --checkbox-s-label-padding-vertical: 0;
  --checkbox-s-border-radius: 3px;
  --checkbox-s-border-width: 2px;
  --checkbox-xs-font: 400 14px/20px var(--font-family);
  --checkbox-xs-height: 20px;
  --checkbox-xs-padding: 2px;
  --checkbox-xs-spacing: 8px;
  --checkbox-xs-label-padding-vertical: 0;
  --checkbox-xs-border-radius: 3px;
  --checkbox-xs-border-width: 2px;
  --chip-primary-bg-color-default: rgba(153, 153, 153, 0.1);
  --chip-primary-bg-color-hover: rgba(153, 153, 153, 0.2);
  --chip-primary-bg-color-disabled: rgba(153, 153, 153, 0.1);
  --chip-primary-bg-color-selected-default: ${COLORS.ACCENT.DEFAULT};
  --chip-primary-bg-color-selected-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --chip-primary-bg-color-selected-disabled: rgba(${ORANGE_COLOR_RGB}, 0.1);
  --chip-primary-border-color-default: rgba(255,255,255,0);
  --chip-primary-border-color-hover: rgba(255,255,255,0);
  --chip-primary-border-color-disabled: rgba(255,255,255,0);
  --chip-primary-border-color-selected-default: rgba(255,255,255,0);
  --chip-primary-border-color-selected-hover: rgba(255,255,255,0);
  --chip-primary-border-color-selected-disabled: rgba(255,255,255,0);
  --chip-primary-label-color-default: ${COLORS.FG.DEFAULT};
  --chip-primary-label-color-hover: ${COLORS.FG.DEFAULT};
  --chip-primary-label-color-disabled: rgba(153, 153, 153, 0.5);
  --chip-primary-label-color-selected-default: #fff;
  --chip-primary-label-color-selected-hover: #fff;
  --chip-primary-label-color-selected-disabled: rgba(153, 153, 153, 0.5);
  --chip-primary-counter-color-default: ${COLORS.FG.DEFAULT};
  --chip-primary-counter-color-hover: ${COLORS.FG.DEFAULT};
  --chip-primary-counter-color-disabled: rgba(153, 153, 153, 0.5);
  --chip-primary-counter-color-selected-default: #fff;
  --chip-primary-counter-color-selected-hover: #fff;
  --chip-primary-counter-color-selected-disabled: rgba(153, 153, 153, 0.5);
  --chip-primary-icon-color-default: ${COLORS.FG.DEFAULT};
  --chip-primary-icon-color-hover: ${COLORS.FG.DEFAULT};
  --chip-primary-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --chip-primary-icon-color-selected-default: #fff;
  --chip-primary-icon-color-selected-hover: #fff;
  --chip-primary-icon-color-selected-disabled: rgba(153, 153, 153, 0.5);
  --chip-primary-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --chip-primary-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --chip-primary-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --chip-primary-shadow-selected-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --chip-primary-shadow-selected-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --chip-primary-shadow-selected-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --chip-secondary-bg-color-default: rgba(255,255,255,0);
  --chip-secondary-bg-color-hover: rgba(255,255,255,0);
  --chip-secondary-bg-color-disabled: rgba(153, 153, 153, 0.1);
  --chip-secondary-bg-color-selected-default: rgba(255,255,255,0);
  --chip-secondary-bg-color-selected-hover: rgba(255,255,255,0);
  --chip-secondary-bg-color-selected-disabled: rgba(153, 153, 153, 0.1);
  --chip-secondary-border-color-default: rgba(153, 153, 153, 0.25);
  --chip-secondary-border-color-hover: ${COLORS.ACCENT.DEFAULT};
  --chip-secondary-border-color-disabled: rgba(255,255,255,0);
  --chip-secondary-border-color-selected-default: ${COLORS.ACCENT.DEFAULT};
  --chip-secondary-border-color-selected-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --chip-secondary-border-color-selected-disabled: rgba(${ORANGE_COLOR_RGB}, 0.1);
  --chip-secondary-label-color-default: ${COLORS.FG.DEFAULT};
  --chip-secondary-label-color-hover: ${COLORS.FG.DEFAULT};
  --chip-secondary-label-color-disabled: rgba(153, 153, 153, 0.5);
  --chip-secondary-label-color-selected-default: ${COLORS.FG.DEFAULT};
  --chip-secondary-label-color-selected-hover: ${COLORS.FG.DEFAULT};
  --chip-secondary-label-color-selected-disabled: rgba(153, 153, 153, 0.5);
  --chip-secondary-counter-color-default: ${COLORS.FG.DEFAULT};
  --chip-secondary-counter-color-hover: ${COLORS.FG.DEFAULT};
  --chip-secondary-counter-color-disabled: rgba(153, 153, 153, 0.5);
  --chip-secondary-counter-color-selected-default: ${COLORS.FG.DEFAULT};
  --chip-secondary-counter-color-selected-hover: ${COLORS.FG.DEFAULT};
  --chip-secondary-counter-color-selected-disabled: rgba(153, 153, 153, 0.5);
  --chip-secondary-icon-color-default: ${COLORS.FG.DEFAULT};
  --chip-secondary-icon-color-hover: ${COLORS.FG.DEFAULT};
  --chip-secondary-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --chip-secondary-icon-color-selected-default: ${COLORS.FG.DEFAULT};
  --chip-secondary-icon-color-selected-hover: ${COLORS.FG.DEFAULT};
  --chip-secondary-icon-color-selected-disabled: rgba(153, 153, 153, 0.5);
  --chip-secondary-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --chip-secondary-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --chip-secondary-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --chip-secondary-shadow-selected-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --chip-secondary-shadow-selected-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --chip-secondary-shadow-selected-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --chip-m-height: ${toRem(28)};
  --chip-m-spacing: 4px;
  --chip-m-padding-left: ${toRem(12)};
  --chip-m-padding-right: ${toRem(12)};
  --chip-m-border-radius: 9999px;
  --chip-m-border-width: 0;
  --chip-m-label-font: 400 16px/24px var(--font-family);
  --chip-m-counter-font: 400 12px/16px var(--font-family);
  --badge-primary-info-bg-color: #47adff;
  --badge-primary-info-border-color: rgba(255,255,255,0);
  --badge-primary-info-label-color: #fff;
  --badge-primary-info-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --badge-primary-warning-bg-color: #f5a733;
  --badge-primary-warning-border-color: rgba(255,255,255,0);
  --badge-primary-warning-label-color: #301d00;
  --badge-primary-warning-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --badge-primary-error-bg-color: #e14453;
  --badge-primary-error-border-color: rgba(255,255,255,0);
  --badge-primary-error-label-color: #fff;
  --badge-primary-error-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --badge-primary-success-bg-color: #34b263;
  --badge-primary-success-border-color: rgba(255,255,255,0);
  --badge-primary-success-label-color: #fff;
  --badge-primary-success-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --badge-primary-neutral-bg-color: #69758d;
  --badge-primary-neutral-border-color: rgba(255,255,255,0);
  --badge-primary-neutral-label-color: #fff;
  --badge-primary-neutral-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --badge-primary-status-01-bg-color: #33c1a0;
  --badge-primary-status-01-border-color: rgba(255,255,255,0);
  --badge-primary-status-01-label-color: #fff;
  --badge-primary-status-01-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --badge-primary-status-02-bg-color: #41a8c9;
  --badge-primary-status-02-border-color: rgba(255,255,255,0);
  --badge-primary-status-02-label-color: #fff;
  --badge-primary-status-02-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --badge-primary-status-03-bg-color: #8775f7;
  --badge-primary-status-03-border-color: rgba(255,255,255,0);
  --badge-primary-status-03-label-color: #fff;
  --badge-primary-status-03-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --badge-primary-status-04-bg-color: #ad50ff;
  --badge-primary-status-04-border-color: rgba(255,255,255,0);
  --badge-primary-status-04-label-color: #fff;
  --badge-primary-status-04-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --badge-primary-status-05-bg-color: #e9619b;
  --badge-primary-status-05-border-color: rgba(255,255,255,0);
  --badge-primary-status-05-label-color: #fff;
  --badge-primary-status-05-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --badge-primary-status-06-bg-color: #fb7533;
  --badge-primary-status-06-border-color: rgba(255,255,255,0);
  --badge-primary-status-06-label-color: #fff;
  --badge-primary-status-06-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --badge-secondary-info-bg-color: rgba(25, 152, 255, 0.1);
  --badge-secondary-info-border-color: rgba(255,255,255,0);
  --badge-secondary-info-label-color: #1998FF;
  --badge-secondary-info-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --badge-secondary-warning-bg-color: rgba(242, 145, 0, 0.1);
  --badge-secondary-warning-border-color: rgba(255,255,255,0);
  --badge-secondary-warning-label-color: #ce7b00;
  --badge-secondary-warning-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --badge-secondary-error-bg-color: rgba(217, 21, 40, 0.1);
  --badge-secondary-error-border-color: rgba(255,255,255,0);
  --badge-secondary-error-label-color: #D91528;
  --badge-secondary-error-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --badge-secondary-success-bg-color: rgba(1, 159, 60, 0.1);
  --badge-secondary-success-border-color: rgba(255,255,255,0);
  --badge-secondary-success-label-color: #019F3C;
  --badge-secondary-success-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --badge-secondary-neutral-bg-color: rgba(153, 153, 153, 0.1);
  --badge-secondary-neutral-border-color: rgba(255,255,255,0);
  --badge-secondary-neutral-label-color: #999999;
  --badge-secondary-neutral-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --badge-secondary-status-01-bg-color: rgba(0, 178, 136, 0.1);
  --badge-secondary-status-01-border-color: rgba(255,255,255,0);
  --badge-secondary-status-01-label-color: #00B288;
  --badge-secondary-status-01-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --badge-secondary-status-02-bg-color: rgba(17, 146, 187, 0.1);
  --badge-secondary-status-02-border-color: rgba(255,255,255,0);
  --badge-secondary-status-02-label-color: #1192BB;
  --badge-secondary-status-02-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --badge-secondary-status-03-bg-color: rgba(105, 82, 245, 0.1);
  --badge-secondary-status-03-border-color: rgba(255,255,255,0);
  --badge-secondary-status-03-label-color: #6952F5;
  --badge-secondary-status-03-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --badge-secondary-status-04-bg-color: rgba(153, 36, 255, 0.1);
  --badge-secondary-status-04-border-color: rgba(255,255,255,0);
  --badge-secondary-status-04-label-color: #9924FF;
  --badge-secondary-status-04-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --badge-secondary-status-05-bg-color: rgba(227, 58, 130, 0.1);
  --badge-secondary-status-05-border-color: rgba(255,255,255,0);
  --badge-secondary-status-05-label-color: #E33A82;
  --badge-secondary-status-05-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --badge-secondary-status-06-bg-color: rgba(250, 83, 0, 0.1);
  --badge-secondary-status-06-border-color: rgba(255,255,255,0);
  --badge-secondary-status-06-label-color: #FA5300;
  --badge-secondary-status-06-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --badge-s-height: 24px;
  --badge-s-padding-left: 8px;
  --badge-s-padding-right: 8px;
  --badge-s-border-radius: 6px;
  --badge-s-border-width: 0;
  --badge-s-font: 600 10px/12px var(--font-family);
  --badge-2xs-height: 16px;
  --badge-2xs-padding-left: 6px;
  --badge-2xs-padding-right: 6px;
  --badge-2xs-border-radius: 6px;
  --badge-2xs-border-width: 0;
  --badge-2xs-font: 600 10px/12px var(--font-family);
  --button-primary-accent-bg-color-default: ${COLORS.ACCENT.DEFAULT};
  --button-primary-accent-bg-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --button-primary-accent-bg-color-active: ${COLORS.ACCENT.DEFAULT};
  --button-primary-accent-bg-color-disabled: rgba(153, 153, 153, 0.1);
  --button-primary-accent-border-color-default: rgba(255,255,255,0);
  --button-primary-accent-border-color-hover: rgba(255,255,255,0);
  --button-primary-accent-border-color-active: rgba(255,255,255,0);
  --button-primary-accent-border-color-disabled: rgba(255,255,255,0);
  --button-primary-accent-label-color-default: #fff;
  --button-primary-accent-label-color-hover: #fff;
  --button-primary-accent-label-color-active: #fff;
  --button-primary-accent-label-color-disabled: rgba(153, 153, 153, 0.5);
  --button-primary-accent-icon-color-default: #fff;
  --button-primary-accent-icon-color-hover: #fff;
  --button-primary-accent-icon-color-active: #fff;
  --button-primary-accent-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --button-primary-accent-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-primary-accent-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-primary-accent-shadow-active: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-primary-accent-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-primary-neutral-bg-color-default: ${COLORS.NEUTRAL.CONTAINER_DEFAULT};
  --button-primary-neutral-bg-color-hover: #3a4760;
  --button-primary-neutral-bg-color-active: #303a4f;
  --button-primary-neutral-bg-color-disabled: rgba(153, 153, 153, 0.1);
  --button-primary-neutral-border-color-default: rgba(255,255,255,0);
  --button-primary-neutral-border-color-hover: rgba(255,255,255,0);
  --button-primary-neutral-border-color-active: rgba(255,255,255,0);
  --button-primary-neutral-border-color-disabled: rgba(255,255,255,0);
  --button-primary-neutral-label-color-default: ${COLORS.FG.DEFAULT};
  --button-primary-neutral-label-color-hover: #fff;
  --button-primary-neutral-label-color-active: #fff;
  --button-primary-neutral-label-color-disabled: rgba(153, 153, 153, 0.5);
  --button-primary-neutral-icon-color-default: #fff;
  --button-primary-neutral-icon-color-hover: #fff;
  --button-primary-neutral-icon-color-active: #fff;
  --button-primary-neutral-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --button-primary-neutral-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-primary-neutral-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-primary-neutral-shadow-active: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-primary-neutral-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-secondary-accent-bg-color-default: rgba(${ORANGE_COLOR_RGB}, 0.1);
  --button-secondary-accent-bg-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.2);
  --button-secondary-accent-bg-color-active: rgba(${ORANGE_COLOR_RGB}, 0.3);
  --button-secondary-accent-bg-color-disabled: rgba(153, 153, 153, 0.1);
  --button-secondary-accent-border-color-default: rgba(255,255,255,0);
  --button-secondary-accent-border-color-hover: rgba(255,255,255,0);
  --button-secondary-accent-border-color-active: rgba(255,255,255,0);
  --button-secondary-accent-border-color-disabled: rgba(255,255,255,0);
  --button-secondary-accent-label-color-default: ${COLORS.ACCENT.DEFAULT};
  --button-secondary-accent-label-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --button-secondary-accent-label-color-active: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --button-secondary-accent-label-color-disabled: rgba(153, 153, 153, 0.5);
  --button-secondary-accent-icon-color-default: ${COLORS.ACCENT.DEFAULT};
  --button-secondary-accent-icon-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --button-secondary-accent-icon-color-active: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --button-secondary-accent-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --button-secondary-accent-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-secondary-accent-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-secondary-accent-shadow-active: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-secondary-accent-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-secondary-neutral-bg-color-default: ${COLORS.NEUTRAL.CONTAINER_DEFAULT};
  --button-secondary-neutral-bg-color-hover: rgba(153, 153, 153, 0.2);
  --button-secondary-neutral-bg-color-active: rgba(153, 153, 153, 0.3);
  --button-secondary-neutral-bg-color-disabled: rgba(153, 153, 153, 0.1);
  --button-secondary-neutral-border-color-default: rgba(255,255,255,0);
  --button-secondary-neutral-border-color-hover: rgba(255,255,255,0);
  --button-secondary-neutral-border-color-active: rgba(255,255,255,0);
  --button-secondary-neutral-border-color-disabled: rgba(255,255,255,0);
  --button-secondary-neutral-label-color-default: #999999;
  --button-secondary-neutral-label-color-hover: #3a4760;
  --button-secondary-neutral-label-color-active: #3a4760;
  --button-secondary-neutral-label-color-disabled: rgba(153, 153, 153, 0.5);
  --button-secondary-neutral-icon-color-default: #999999;
  --button-secondary-neutral-icon-color-hover: #3a4760;
  --button-secondary-neutral-icon-color-active: #3a4760;
  --button-secondary-neutral-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --button-secondary-neutral-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-secondary-neutral-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-secondary-neutral-shadow-active: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-secondary-neutral-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-outline-accent-bg-color-default: rgba(255,255,255,0);
  --button-outline-accent-bg-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.1);
  --button-outline-accent-bg-color-active: rgba(${ORANGE_COLOR_RGB}, 0.2);
  --button-outline-accent-bg-color-disabled: rgba(255,255,255,0);
  --button-outline-accent-border-color-default: ${GRAYSCALE_91_COLOR};
  --button-outline-accent-border-color-hover: ${COLORS.ACCENT.DEFAULT};
  --button-outline-accent-border-color-active: ${COLORS.ACCENT.DEFAULT};
  --button-outline-accent-border-color-disabled: rgba(153, 153, 153, 0.15);
  --button-outline-accent-label-color-default: ${COLORS.FG.DEFAULT};
  --button-outline-accent-label-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --button-outline-accent-label-color-active: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --button-outline-accent-label-color-disabled: rgba(153, 153, 153, 0.5);
  --button-outline-accent-icon-color-default: ${COLORS.ACCENT.DEFAULT};
  --button-outline-accent-icon-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --button-outline-accent-icon-color-active: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --button-outline-accent-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --button-outline-accent-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-outline-accent-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-outline-accent-shadow-active: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-outline-accent-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-outline-neutral-bg-color-default: rgba(255,255,255,0);
  --button-outline-neutral-bg-color-hover: rgba(153, 153, 153, 0.1);
  --button-outline-neutral-bg-color-active: rgba(153, 153, 153, 0.2);
  --button-outline-neutral-bg-color-disabled: rgba(255,255,255,0);
  --button-outline-neutral-border-color-default: rgba(153, 153, 153, 0.15);
  --button-outline-neutral-border-color-hover: rgba(153, 153, 153, 0.25);
  --button-outline-neutral-border-color-active: rgba(153, 153, 153, 0.25);
  --button-outline-neutral-border-color-disabled: rgba(153, 153, 153, 0.15);
  --button-outline-neutral-label-color-default: #999999;
  --button-outline-neutral-label-color-hover: #3a4760;
  --button-outline-neutral-label-color-active: #3a4760;
  --button-outline-neutral-label-color-disabled: rgba(153, 153, 153, 0.5);
  --button-outline-neutral-icon-color-default: #999999;
  --button-outline-neutral-icon-color-hover: #3a4760;
  --button-outline-neutral-icon-color-active: #3a4760;
  --button-outline-neutral-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --button-outline-neutral-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-outline-neutral-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-outline-neutral-shadow-active: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-outline-neutral-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-ghost-accent-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-ghost-accent-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-ghost-accent-shadow-active: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-ghost-accent-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-ghost-accent-bg-color-default: rgba(255,255,255,0);
  --button-ghost-accent-bg-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.1);
  --button-ghost-accent-bg-color-active: rgba(${ORANGE_COLOR_RGB}, 0.2);
  --button-ghost-accent-bg-color-disabled: rgba(255,255,255,0);
  --button-ghost-accent-border-color-default: rgba(255,255,255,0);
  --button-ghost-accent-border-color-hover: rgba(255,255,255,0);
  --button-ghost-accent-border-color-active: rgba(255,255,255,0);
  --button-ghost-accent-border-color-disabled: rgba(255,255,255,0);
  --button-ghost-accent-label-color-default: ${COLORS.ACCENT.DEFAULT};
  --button-ghost-accent-label-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --button-ghost-accent-label-color-active: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --button-ghost-accent-label-color-disabled: ${COLORS.FG.DEFAULT};
  --button-ghost-accent-icon-color-default: ${COLORS.ACCENT.DEFAULT};
  --button-ghost-accent-icon-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --button-ghost-accent-icon-color-active: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --button-ghost-accent-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --button-ghost-neutral-bg-color-default: rgba(255,255,255,0);
  --button-ghost-neutral-bg-color-hover: rgba(153, 153, 153, 0.1);
  --button-ghost-neutral-bg-color-active: rgba(153, 153, 153, 0.2);
  --button-ghost-neutral-bg-color-disabled: rgba(255,255,255,0);
  --button-ghost-neutral-border-color-default: rgba(255,255,255,0);
  --button-ghost-neutral-border-color-hover: rgba(255,255,255,0);
  --button-ghost-neutral-border-color-active: rgba(255,255,255,0);
  --button-ghost-neutral-border-color-disabled: rgba(255,255,255,0);
  --button-ghost-neutral-label-color-default: ${COLORS.NEUTRAL.MUTED};
  --button-ghost-neutral-label-color-hover: #3a4760;
  --button-ghost-neutral-label-color-active: #3a4760;
  --button-ghost-neutral-label-color-disabled: rgba(153, 153, 153, 0.5);
  --button-ghost-neutral-icon-color-default: ${COLORS.NEUTRAL.MUTED};
  --button-ghost-neutral-icon-color-hover: #3a4760;
  --button-ghost-neutral-icon-color-active: #3a4760;
  --button-ghost-neutral-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --button-ghost-neutral-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-ghost-neutral-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-ghost-neutral-shadow-active: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-ghost-neutral-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --button-xl-height: 56px;
  --button-xl-min-width: 56px;
  --button-xl-font: 600 16px/24px var(--font-family);
  --button-xl-spacing: 4px;
  --button-xl-padding-left: 20px;
  --button-xl-padding-right: 20px;
  --button-xl-label-padding-horizontal: 4px;
  --button-xl-border-radius: 6px;
  --button-xl-border-width: 2px;
  --button-l-font: 600 16px/24px var(--font-family);
  --button-l-height: 48px;
  --button-l-min-width: 48px;
  --button-l-spacing: 4px;
  --button-l-padding-left: ${toRem(8)};
  --button-l-padding-right: ${toRem(8)};
  --button-l-label-padding-horizontal: 4px;
  --button-l-border-radius: 6px;
  --button-l-border-width: 2px;
  --button-m-font: 600 14px/20px var(--font-family);
  --button-m-height: 36px;
  --button-m-min-width: 36px;
  --button-m-spacing: 0;
  --button-m-padding-left: ${toRem(6)};
  --button-m-padding-right: ${toRem(6)};
  --button-m-label-padding-horizontal: 4px;
  --button-m-border-radius: 6px;
  --button-m-border-width: 2px;
  --button-s-font: 600 12px/16px var(--font-family);
  --button-s-height: 24px;
  --button-s-min-width: 24px;
  --button-s-spacing: 0;
  --button-s-padding-left: 2px;
  --button-s-padding-right: 2px;
  --button-s-label-padding-horizontal: 4px;
  --button-s-border-radius: 6px;
  --button-s-border-width: 2px;
  --closebutton-primary-bg-color-default: rgba(153, 153, 153, 0.1);
  --closebutton-primary-bg-color-hover: rgba(153, 153, 153, 0.2);
  --closebutton-primary-bg-color-active: rgba(153, 153, 153, 0.3);
  --closebutton-primary-border-color-default: rgba(255,255,255,0);
  --closebutton-primary-border-color-hover: rgba(255,255,255,0);
  --closebutton-primary-border-color-active: rgba(255,255,255,0);
  --closebutton-primary-icon-color-default: #999999;
  --closebutton-primary-icon-color-hover: #3a4760;
  --closebutton-primary-icon-color-active: #3a4760;
  --closebutton-primary-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --closebutton-primary-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --closebutton-primary-shadow-active: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --closebutton-l-height: 48px;
  --closebutton-l-border-radius: 6px;
  --closebutton-l-border-width: 0;
  --closebutton-m-height: 36px;
  --closebutton-m-border-radius: 6px;
  --closebutton-m-border-width: 0;
  --closebutton-s-height: 24px;
  --closebutton-s-border-radius: 6px;
  --closebutton-s-border-width: 0;
  --closebutton-xs-height: 20px;
  --closebutton-xs-border-radius: 4px;
  --closebutton-xs-border-width: 0;
  --closebutton-2xs-height: 16px;
  --closebutton-2xs-border-radius: 4px;
  --closebutton-2xs-border-width: 0;
  --iconbutton-primary-accent-bg-color-default: ${COLORS.ACCENT.DEFAULT};
  --iconbutton-primary-accent-bg-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --iconbutton-primary-accent-bg-color-active: ${COLORS.ACCENT.DEFAULT};
  --iconbutton-primary-accent-bg-color-disabled: rgba(153, 153, 153, 0.1);
  --iconbutton-primary-accent-border-color-default: rgba(255,255,255,0);
  --iconbutton-primary-accent-border-color-hover: rgba(255,255,255,0);
  --iconbutton-primary-accent-border-color-active: rgba(255,255,255,0);
  --iconbutton-primary-accent-border-color-disabled: rgba(255,255,255,0);
  --iconbutton-primary-accent-icon-color-default: #fff;
  --iconbutton-primary-accent-icon-color-hover: #fff;
  --iconbutton-primary-accent-icon-color-active: #fff;
  --iconbutton-primary-accent-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --iconbutton-primary-accent-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-primary-accent-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-primary-accent-shadow-active: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-primary-accent-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-primary-neutral-bg-color-default: #999999;
  --iconbutton-primary-neutral-bg-color-hover: #3a4760;
  --iconbutton-primary-neutral-bg-color-active: #303a4f;
  --iconbutton-primary-neutral-bg-color-disabled: rgba(153, 153, 153, 0.1);
  --iconbutton-primary-neutral-border-color-default: rgba(255,255,255,0);
  --iconbutton-primary-neutral-border-color-hover: rgba(255,255,255,0);
  --iconbutton-primary-neutral-border-color-active: rgba(255,255,255,0);
  --iconbutton-primary-neutral-border-color-disabled: rgba(255,255,255,0);
  --iconbutton-primary-neutral-icon-color-default: #fff;
  --iconbutton-primary-neutral-icon-color-hover: #fff;
  --iconbutton-primary-neutral-icon-color-active: #fff;
  --iconbutton-primary-neutral-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --iconbutton-primary-neutral-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-primary-neutral-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-primary-neutral-shadow-active: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-primary-neutral-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-secondary-accent-bg-color-default: rgba(${ORANGE_COLOR_RGB}, 0.1);
  --iconbutton-secondary-accent-bg-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.2);
  --iconbutton-secondary-accent-bg-color-active: rgba(${ORANGE_COLOR_RGB}, 0.3);
  --iconbutton-secondary-accent-bg-color-disabled: rgba(153, 153, 153, 0.1);
  --iconbutton-secondary-accent-border-color-default: rgba(255,255,255,0);
  --iconbutton-secondary-accent-border-color-hover: rgba(255,255,255,0);
  --iconbutton-secondary-accent-border-color-active: rgba(255,255,255,0);
  --iconbutton-secondary-accent-border-color-disabled: rgba(255,255,255,0);
  --iconbutton-secondary-accent-icon-color-default: ${COLORS.ACCENT.DEFAULT};
  --iconbutton-secondary-accent-icon-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --iconbutton-secondary-accent-icon-color-active: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --iconbutton-secondary-accent-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --iconbutton-secondary-accent-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-secondary-accent-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-secondary-accent-shadow-active: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-secondary-accent-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-secondary-neutral-bg-color-default: rgba(153, 153, 153, 0.1);
  --iconbutton-secondary-neutral-bg-color-hover: rgba(153, 153, 153, 0.2);
  --iconbutton-secondary-neutral-bg-color-active: rgba(153, 153, 153, 0.3);
  --iconbutton-secondary-neutral-bg-color-disabled: rgba(153, 153, 153, 0.1);
  --iconbutton-secondary-neutral-border-color-default: rgba(255,255,255,0);
  --iconbutton-secondary-neutral-border-color-hover: rgba(255,255,255,0);
  --iconbutton-secondary-neutral-border-color-active: rgba(255,255,255,0);
  --iconbutton-secondary-neutral-border-color-disabled: rgba(255,255,255,0);
  --iconbutton-secondary-neutral-icon-color-default: #999999;
  --iconbutton-secondary-neutral-icon-color-hover: #3a4760;
  --iconbutton-secondary-neutral-icon-color-active: #3a4760;
  --iconbutton-secondary-neutral-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --iconbutton-secondary-neutral-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-secondary-neutral-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-secondary-neutral-shadow-active: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-secondary-neutral-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-outline-accent-bg-color-default: rgba(255,255,255,0);
  --iconbutton-outline-accent-bg-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.1);
  --iconbutton-outline-accent-bg-color-active: rgba(${ORANGE_COLOR_RGB}, 0.2);
  --iconbutton-outline-accent-bg-color-disabled: rgba(255,255,255,0);
  --iconbutton-outline-accent-border-color-default: #80aaff;
  --iconbutton-outline-accent-border-color-hover: ${COLORS.ACCENT.DEFAULT};
  --iconbutton-outline-accent-border-color-active: ${COLORS.ACCENT.DEFAULT};
  --iconbutton-outline-accent-border-color-disabled: rgba(153, 153, 153, 0.15);
  --iconbutton-outline-accent-icon-color-default: ${COLORS.ACCENT.DEFAULT};
  --iconbutton-outline-accent-icon-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --iconbutton-outline-accent-icon-color-active: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --iconbutton-outline-accent-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --iconbutton-outline-accent-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-outline-accent-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-outline-accent-shadow-active: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-outline-accent-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-outline-neutral-bg-color-default: rgba(255,255,255,0);
  --iconbutton-outline-neutral-bg-color-hover: rgba(153, 153, 153, 0.1);
  --iconbutton-outline-neutral-bg-color-active: rgba(153, 153, 153, 0.2);
  --iconbutton-outline-neutral-bg-color-disabled: rgba(255,255,255,0);
  --iconbutton-outline-neutral-border-color-default: rgba(153, 153, 153, 0.15);
  --iconbutton-outline-neutral-border-color-hover: rgba(153, 153, 153, 0.25);
  --iconbutton-outline-neutral-border-color-active: rgba(153, 153, 153, 0.25);
  --iconbutton-outline-neutral-border-color-disabled: rgba(153, 153, 153, 0.15);
  --iconbutton-outline-neutral-icon-color-default: #999999;
  --iconbutton-outline-neutral-icon-color-hover: #3a4760;
  --iconbutton-outline-neutral-icon-color-active: #3a4760;
  --iconbutton-outline-neutral-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --iconbutton-outline-neutral-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-outline-neutral-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-outline-neutral-shadow-active: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-outline-neutral-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-ghost-accent-bg-color-default: rgba(255,255,255,0);
  --iconbutton-ghost-accent-bg-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.1);
  --iconbutton-ghost-accent-bg-color-active: rgba(${ORANGE_COLOR_RGB}, 0.2);
  --iconbutton-ghost-accent-bg-color-disabled: rgba(255,255,255,0);
  --iconbutton-ghost-accent-border-color-default: rgba(255,255,255,0);
  --iconbutton-ghost-accent-border-color-hover: rgba(255,255,255,0);
  --iconbutton-ghost-accent-border-color-active: rgba(255,255,255,0);
  --iconbutton-ghost-accent-border-color-disabled: rgba(255,255,255,0);
  --iconbutton-ghost-accent-icon-color-default: ${COLORS.ACCENT.DEFAULT};
  --iconbutton-ghost-accent-icon-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --iconbutton-ghost-accent-icon-color-active: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --iconbutton-ghost-accent-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --iconbutton-ghost-accent-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-ghost-accent-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-ghost-accent-shadow-active: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-ghost-accent-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-ghost-neutral-bg-color-default: rgba(255,255,255,0);
  --iconbutton-ghost-neutral-bg-color-hover: rgba(153, 153, 153, 0.1);
  --iconbutton-ghost-neutral-bg-color-active: rgba(153, 153, 153, 0.2);
  --iconbutton-ghost-neutral-bg-color-disabled: rgba(255,255,255,0);
  --iconbutton-ghost-neutral-border-color-default: rgba(255,255,255,0);
  --iconbutton-ghost-neutral-border-color-hover: rgba(255,255,255,0);
  --iconbutton-ghost-neutral-border-color-active: rgba(255,255,255,0);
  --iconbutton-ghost-neutral-border-color-disabled: rgba(255,255,255,0);
  --iconbutton-ghost-neutral-icon-color-default: #999999;
  --iconbutton-ghost-neutral-icon-color-hover: #3a4760;
  --iconbutton-ghost-neutral-icon-color-active: #3a4760;
  --iconbutton-ghost-neutral-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --iconbutton-ghost-neutral-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-ghost-neutral-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-ghost-neutral-shadow-active: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-ghost-neutral-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --iconbutton-xl-height: 56px;
  --iconbutton-xl-border-radius: 6px;
  --iconbutton-xl-border-width: 2px;
  --iconbutton-l-height: 48px;
  --iconbutton-l-border-radius: 6px;
  --iconbutton-l-border-width: 2px;
  --iconbutton-m-height: 36px;
  --iconbutton-m-border-radius: 6px;
  --iconbutton-m-border-width: 2px;
  --iconbutton-s-height: 24px;
  --iconbutton-s-border-radius: 6px;
  --iconbutton-s-border-width: 2px;
  --loader-m-height: 36px;
  --loader-s-height: 24px;
  --loader-2xs-height: 16px;
  --loader-primary-bg-first-color: ${COLORS.ACCENT.DEFAULT};
  --loader-primary-bg-second-color: #80aaff;
  --loader-secondary-bg-first-color: #999999;
  --loader-secondary-bg-second-color: #a2a9b8;
  --scroll-track-bg-color-default: rgba(153, 153, 153, 0.1);
  --scroll-track-bg-color-hover: rgba(153, 153, 153, 0.1);
  --scroll-knob-bg-color-default: #a2a9b8;
  --scroll-knob-bg-color-hover: #69758d;
  --scroll-knob-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --scroll-knob-shadow-hover: 0 0 8px 0 rgba(153, 153, 153, 0.1), 0 2px 4px 0 rgba(153, 153, 153, 0.05);
  --scroll-size: 4px;
  --radiobutton-s-height: 24px;
  --radiobutton-s-padding: 1px;
  --radiobutton-s-spacing: 8px;
  --radiobutton-s-label-padding-vertical: 0;
  --radiobutton-s-border-radius: 9999px;
  --radiobutton-s-border-width: 2px;
  --radiobutton-s-font: 400 16px/24px var(--font-family);
  --radiobutton-xs-height: 20px;
  --radiobutton-xs-padding: 1px;
  --radiobutton-xs-spacing: 8px;
  --radiobutton-xs-label-padding-vertical: 0;
  --radiobutton-xs-border-radius: 9999px;
  --radiobutton-xs-border-width: 2px;
  --radiobutton-xs-font: 400 14px/20px var(--font-family);
  --radiobutton-primary-bg-color-default: rgba(255,255,255,0);
  --radiobutton-primary-bg-color-hover: rgba(255,255,255,0);
  --radiobutton-primary-bg-color-disabled: rgba(153, 153, 153, 0.1);
  --radiobutton-primary-bg-color-checked-default: ${COLORS.ACCENT.DEFAULT};
  --radiobutton-primary-bg-color-checked-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --radiobutton-primary-bg-color-checked-disabled: rgba(153, 153, 153, 0.1);
  --radiobutton-primary-border-color-default: rgba(153, 153, 153, 0.25);
  --radiobutton-primary-border-color-hover: ${COLORS.ACCENT.DEFAULT};
  --radiobutton-primary-border-color-disabled: rgba(255,255,255,0);
  --radiobutton-primary-border-color-checked-default: rgba(255,255,255,0);
  --radiobutton-primary-border-color-checked-hover: rgba(255,255,255,0);
  --radiobutton-primary-border-color-checked-disabled: rgba(255,255,255,0);
  --radiobutton-primary-label-color-default: ${COLORS.FG.DEFAULT};
  --radiobutton-primary-label-color-hover: ${COLORS.FG.DEFAULT};
  --radiobutton-primary-label-color-disabled: rgba(153, 153, 153, 0.5);
  --radiobutton-primary-label-color-checked-default: ${COLORS.FG.DEFAULT};
  --radiobutton-primary-label-color-checked-hover: ${COLORS.FG.DEFAULT};
  --radiobutton-primary-label-color-checked-disabled: rgba(153, 153, 153, 0.5);
  --radiobutton-primary-icon-color-checked-default: #fff;
  --radiobutton-primary-icon-color-checked-hover: #fff;
  --radiobutton-primary-icon-color-checked-disabled: rgba(153, 153, 153, 0.5);
  --radiobutton-primary-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --radiobutton-primary-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --radiobutton-primary-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --radiobutton-primary-shadow-checked-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --radiobutton-primary-shadow-checked-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --radiobutton-primary-shadow-checked-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --radiobutton-primary-frame-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --radiobutton-primary-frame-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --radiobutton-primary-frame-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --radiobutton-primary-frame-checked-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --radiobutton-primary-frame-checked-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --radiobutton-primary-frame-checked-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --radiobutton-secondary-bg-color-default: rgba(255,255,255,0);
  --radiobutton-secondary-bg-color-hover: rgba(255,255,255,0);
  --radiobutton-secondary-bg-color-disabled: rgba(153, 153, 153, 0.1);
  --radiobutton-secondary-bg-color-checked-default: rgba(255,255,255,0);
  --radiobutton-secondary-bg-color-checked-hover: rgba(255,255,255,0);
  --radiobutton-secondary-bg-color-checked-disabled: rgba(153, 153, 153, 0.1);
  --radiobutton-secondary-border-color-default: rgba(153, 153, 153, 0.25);
  --radiobutton-secondary-border-color-hover: ${COLORS.ACCENT.DEFAULT};
  --radiobutton-secondary-border-color-disabled: rgba(255,255,255,0);
  --radiobutton-secondary-border-color-checked-default: ${COLORS.ACCENT.DEFAULT};
  --radiobutton-secondary-border-color-checked-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --radiobutton-secondary-border-color-checked-disabled: rgba(255,255,255,0);
  --radiobutton-secondary-label-color-default: ${COLORS.FG.DEFAULT};
  --radiobutton-secondary-label-color-hover: ${COLORS.FG.DEFAULT};
  --radiobutton-secondary-label-color-disabled: rgba(153, 153, 153, 0.5);
  --radiobutton-secondary-label-color-checked-default: ${COLORS.FG.DEFAULT};
  --radiobutton-secondary-label-color-checked-hover: ${COLORS.FG.DEFAULT};
  --radiobutton-secondary-label-color-checked-disabled: rgba(153, 153, 153, 0.5);
  --radiobutton-secondary-icon-color-checked-default: ${COLORS.FG.DEFAULT};
  --radiobutton-secondary-icon-color-checked-hover: #999999;
  --radiobutton-secondary-icon-color-checked-disabled: rgba(153, 153, 153, 0.5);
  --radiobutton-secondary-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --radiobutton-secondary-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --radiobutton-secondary-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --radiobutton-secondary-shadow-checked-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --radiobutton-secondary-shadow-checked-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --radiobutton-secondary-shadow-checked-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --radiobutton-secondary-frame-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --radiobutton-secondary-frame-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --radiobutton-secondary-frame-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --radiobutton-secondary-frame-shadow-checked-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --radiobutton-secondary-frame-shadow-checked-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --radiobutton-secondary-frame-shadow-checked-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --functionbutton-primary-label-color-default: ${COLORS.ACCENT.DEFAULT};
  --functionbutton-primary-label-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --functionbutton-primary-label-color-active: ${COLORS.ACCENT.DEFAULT};
  --functionbutton-primary-label-color-disabled: rgba(153, 153, 153, 0.5);
  --functionbutton-primary-icon-color-default: ${COLORS.ACCENT.DEFAULT};
  --functionbutton-primary-icon-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --functionbutton-primary-icon-color-active: ${COLORS.ACCENT.DEFAULT};
  --functionbutton-primary-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --functionbutton-secondary-label-color-default: ${COLORS.FG.DEFAULT};
  --functionbutton-secondary-label-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --functionbutton-secondary-label-color-active: ${COLORS.ACCENT.DEFAULT};
  --functionbutton-secondary-label-color-disabled: rgba(153, 153, 153, 0.5);
  --functionbutton-secondary-icon-color-default: ${COLORS.FG.DEFAULT};
  --functionbutton-secondary-icon-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --functionbutton-secondary-icon-color-active: ${COLORS.ACCENT.DEFAULT};
  --functionbutton-secondary-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --functionbutton-tertiary-label-color-default: #999999;
  --functionbutton-tertiary-label-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --functionbutton-tertiary-label-color-active: ${COLORS.ACCENT.DEFAULT};
  --functionbutton-tertiary-label-color-disabled: rgba(153, 153, 153, 0.5);
  --functionbutton-tertiary-icon-color-default: #999999;
  --functionbutton-tertiary-icon-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --functionbutton-tertiary-icon-color-active: ${COLORS.ACCENT.DEFAULT};
  --functionbutton-tertiary-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --functionbutton-s-spacing: 4px;
  --functionbutton-s-label-padding-vertical: 2px;
  --functionbutton-s-font: 600 14px/20px var(--font-family);
  --taginput-m-height: 28px;
  --taginput-m-padding-left: 8px;
  --taginput-m-padding-right: 8px;
  --taginput-m-border-radius: 6px;
  --taginput-m-border-width: 0;
  --taginput-m-font: 400 14px/20px var(--font-family);
  --taginput-s-height: 20px;
  --taginput-s-padding-left: 6px;
  --taginput-s-padding-right: 6px;
  --taginput-s-border-radius: 4px;
  --taginput-s-border-width: 0;
  --taginput-s-font: 400 12px/16px var(--font-family);
  --taginput-xs-height: 16px;
  --taginput-xs-padding-left: 6px;
  --taginput-xs-padding-right: 6px;
  --taginput-xs-border-radius: 4px;
  --taginput-xs-border-width: 0;
  --taginput-xs-font: 400 12px/16px var(--font-family);
  --taginput-primary-bg-color: ${COLORS.NEUTRAL.CONTAINER_SOFT};
  --taginput-primary-border-color: rgba(255,255,255,0);
  --taginput-primary-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --taginput-primary-inputvalue-color: ${COLORS.FG.DEFAULT};
  --taginput-secondary-bg-color: #fff;
  --taginput-secondary-border-color: rgba(255,255,255,0);
  --taginput-secondary-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --taginput-secondary-inputvalue-color: ${COLORS.FG.DEFAULT};
  --tagmore-m-height: 28px;
  --tagmore-m-spacing: 4px;
  --tagmore-m-padding-left: 8px;
  --tagmore-m-padding-right: 8px;
  --tagmore-m-border-radius: 6px;
  --tagmore-m-border-width: 0;
  --tagmore-m-font: 400 14px/20px var(--font-family);
  --tagmore-s-height: 20px;
  --tagmore-s-spacing: 4px;
  --tagmore-s-padding-left: 6px;
  --tagmore-s-padding-right: 6px;
  --tagmore-s-border-radius: 4px;
  --tagmore-s-border-width: 0;
  --tagmore-s-font: 400 12px/16px var(--font-family);
  --tagmore-xs-height: 16px;
  --tagmore-xs-spacing: 4px;
  --tagmore-xs-padding-left: 6px;
  --tagmore-xs-padding-right: 6px;
  --tagmore-xs-border-radius: 4px;
  --tagmore-xs-border-width: 0;
  --tagmore-xs-font: 400 12px/16px var(--font-family);
  --tagmore-primary-bg-color-default: rgba(153, 153, 153, 0.1);
  --tagmore-primary-bg-color-hover: rgba(153, 153, 153, 0.05);
  --tagmore-primary-border-color-default: rgba(255,255,255,0);
  --tagmore-primary-border-color-hover: rgba(255,255,255,0);
  --tagmore-primary-label-color-default: #999999;
  --tagmore-primary-label-color-hover: ${COLORS.FG.MUTED};
  --tagmore-primary-icon-color-default: ${COLORS.FG.DEFAULT};
  --tagmore-primary-icon-color-hover: ${COLORS.FG.DEFAULT};
  --tagmore-primary-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --tagmore-primary-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --tagmore-secondary-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --tagmore-secondary-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --tagmore-secondary-bg-color-default: #fff;
  --tagmore-secondary-bg-color-hover: #fff;
  --tagmore-secondary-border-color-default: rgba(255,255,255,0);
  --tagmore-secondary-border-color-hover: rgba(255,255,255,0);
  --tagmore-secondary-label-color-default: #999999;
  --tagmore-secondary-label-color-hover: ${COLORS.FG.DEFAULT};
  --tagmore-secondary-icon-color-default: #999999;
  --tagmore-secondary-icon-color-hover: ${COLORS.FG.DEFAULT};
  --tagitem-m-height: 28px;
  --tagitem-m-spacing: 4px;
  --tagitem-m-padding-left: 8px;
  --tagitem-m-padding-right: 8px;
  --tagitem-m-border-radius: 6px;
  --tagitem-m-border-width: 0;
  --tagitem-m-font: 400 14px/20px var(--font-family);
  --tagitem-s-height: 20px;
  --tagitem-s-spacing: 4px;
  --tagitem-s-padding-left: 6px;
  --tagitem-s-padding-right: 6px;
  --tagitem-s-border-radius: 4px;
  --tagitem-s-border-width: 0;
  --tagitem-s-font: 400 12px/16px var(--font-family);
  --tagitem-xs-height: 16px;
  --tagitem-xs-spacing: 4px;
  --tagitem-xs-padding-left: 6px;
  --tagitem-xs-padding-right: 6px;
  --tagitem-xs-border-radius: 4px;
  --tagitem-xs-border-width: 0;
  --tagitem-xs-font: 400 12px/16px var(--font-family);
  --tagitem-primary-bg-color-default: ${COLORS.NEUTRAL.CONTAINER_DEFAULT};
  --tagitem-primary-bg-color-hover: rgba(153, 153, 153, 0.05);
  --tagitem-primary-bg-color-error: rgba(217, 21, 40, 0.1);
  --tagitem-primary-bg-color-disabled: rgba(153, 153, 153, 0.1);
  --tagitem-primary-border-color-default: rgba(255,255,255,0);
  --tagitem-primary-border-color-hover: rgba(255,255,255,0);
  --tagitem-primary-border-color-error: rgba(255,255,255,0);
  --tagitem-primary-border-color-disabled: rgba(255,255,255,0);
  --tagitem-primary-label-color-default: ${COLORS.FG.DEFAULT};
  --tagitem-primary-label-color-hover: ${COLORS.FG.DEFAULT};
  --tagitem-primary-label-color-error: #D91528;
  --tagitem-primary-label-color-disabled: rgba(153, 153, 153, 0.5);
  --tagitem-primary-icon-color-default: #858fa3;
  --tagitem-primary-icon-color-hover: ${COLORS.FG.DEFAULT};
  --tagitem-primary-icon-color-error: #858fa3;
  --tagitem-primary-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --tagitem-primary-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --tagitem-primary-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --tagitem-primary-shadow-error: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --tagitem-primary-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --tagitem-secondary-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --tagitem-secondary-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --tagitem-secondary-shadow-error: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --tagitem-secondary-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --tagitem-secondary-bg-color-default: transparent;
  --tagitem-secondary-bg-color-hover: #fff;
  --tagitem-secondary-bg-color-error: #fff;
  --tagitem-secondary-bg-color-disabled: rgba(153, 153, 153, 0.1);
  --tagitem-secondary-border-color-default: rgba(255,255,255,0);
  --tagitem-secondary-border-color-hover: rgba(255,255,255,0);
  --tagitem-secondary-border-color-error: rgba(255,255,255,0);
  --tagitem-secondary-border-color-disabled: rgba(255,255,255,0);
  --tagitem-secondary-label-color-default: ${COLORS.FG.DEFAULT};
  --tagitem-secondary-label-color-hover: ${COLORS.FG.DEFAULT};
  --tagitem-secondary-label-color-error: #D91528;
  --tagitem-secondary-label-color-disabled: rgba(153, 153, 153, 0.5);
  --tagitem-secondary-icon-color-default: #858fa3;
  --tagitem-secondary-icon-color-hover: ${COLORS.FG.DEFAULT};
  --tagitem-secondary-icon-color-error: #858fa3;
  --tagitem-secondary-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --taggroup-m-spacing-horizontal: 8px;
  --taggroup-m-spacing-vertical: 8px;
  --taggroup-s-spacing-horizontal: 4px;
  --taggroup-s-spacing-vertical: 4px;
  --taggroup-xs-spacing-horizontal: 4px;
  --taggroup-xs-spacing-vertical: 4px;
  --input-l-height: 48px;
  --input-l-border-radius: 6px;
  --input-l-border-width: 2px;
  --input-l-spacing: 8px;
  --input-l-padding-left: 12px;
  --input-l-padding-right: 12px;
  --input-l-labelinside-spacing: 0;
  --input-l-label-font: 400 12px/16px var(--font-family);
  --input-l-label-font-empty: 400 16px/24px var(--font-family);
  --input-l-labeloutside-spacing: 8px;
  --input-l-hint-padding-left: 12px;
  --input-l-hint-padding-right: 12px;
  --input-l-hint-font: 400 12px/16px var(--font-family);
  --input-l-counter-spacing: 0;
  --input-l-placeholder-font: 400 16px/24px var(--font-family);
  --input-l-inputvalue-font: 400 16px/24px var(--font-family);
  --input-m-height: 36px;
  --input-m-border-radius: 6px;
  --input-m-border-width: 2px;
  --input-m-spacing: 8px;
  --input-m-padding-left: 12px;
  --input-m-padding-right: 12px;
  --input-m-labeloutside-spacing: 4px;
  --input-m-label-font: 400 12px/16px var(--font-family);
  --input-m-hint-padding-left: 0;
  --input-m-hint-padding-right: 0;
  --input-m-hint-font: 400 12px/16px var(--font-family);
  --input-m-counter-spacing: 0;
  --input-m-placeholder-font: 400 14px/20px var(--font-family);
  --input-m-inputvalue-font: 400 14px/20px var(--font-family);
  --input-s-height: 24px;
  --input-s-border-radius: 6px;
  --input-s-border-width: 2px;
  --input-s-spacing: 4px;
  --input-s-padding-left: 8px;
  --input-s-padding-right: 8px;
  --input-s-labeloutside-spacing: 4px;
  --input-s-label-font: 400 12px/16px var(--font-family);
  --input-s-hint-padding-left: 0;
  --input-s-hint-padding-right: 0;
  --input-s-hint-font: 400 12px/16px var(--font-family);
  --input-s-counter-spacing: 0;
  --input-s-placeholder-font: 400 12px/16px var(--font-family);
  --input-s-inputvalue-font: 400 12px/16px var(--font-family);
  --input-primary-bg-color-default: ${COLORS.NEUTRAL.CONTAINER_DEFAULT};
  --input-primary-bg-color-hover: ${COLORS.BG.SURFACE1};
  --input-primary-bg-color-focus: ${COLORS.BG.SURFACE1};
  --input-primary-bg-color-error: ${COLORS.NEUTRAL.CONTAINER_DEFAULT};
  --input-primary-bg-color-disabled: rgba(153, 153, 153, 0.1);
  --input-primary-border-color-default: rgba(0,0,0,0);
  --input-primary-border-color-hover: ${COLORS.ACCENT.DEFAULT};
  --input-primary-border-color-focus: ${COLORS.ACCENT.DEFAULT};
  --input-primary-border-color-error: rgba(0,0,0,0);
  --input-primary-border-color-disabled: rgba(255,255,255,0);
  --input-primary-label-color-default: #999999;
  --input-primary-label-color-hover: #999999;
  --input-primary-label-color-focus: ${COLORS.ACCENT.DEFAULT};
  --input-primary-label-color-error: #D91528;
  --input-primary-label-color-disabled: rgba(153, 153, 153, 0.5);
  --input-primary-placeholder-color-default: #858fa3;
  --input-primary-placeholder-color-error: #858fa3;
  --input-primary-placeholder-color-disabled: rgba(153, 153, 153, 0.5);
  --input-primary-inputvalue-color-default: ${COLORS.FG.DEFAULT};
  --input-primary-inputvalue-color-error: ${COLORS.FG.DEFAULT};
  --input-primary-inputvalue-color-disabled: rgba(153, 153, 153, 0.5);
  --input-primary-hint-color-default: #858fa3;
  --input-primary-hint-color-error: #D91528;
  --input-primary-hint-color-disabled: rgba(153, 153, 153, 0.5);
  --input-primary-counter-color-default: #858fa3;
  --input-primary-counter-color-error: #858fa3;
  --input-primary-counter-color-disabled: rgba(153, 153, 153, 0.5);
  --input-primary-icon-color-default: #858fa3;
  --input-primary-icon-color-hover: ${COLORS.FG.DEFAULT};
  --input-primary-icon-color-error: #858fa3;
  --input-primary-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --input-primary-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --input-primary-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --input-primary-shadow-focus: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --input-primary-shadow-error: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --input-primary-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --select-l-dropdownmenu-offset: 4px;
  --select-m-dropdownmenu-offset: 4px;
  --select-s-dropdownmenu-offset: 4px;
  --inputdate-l-pickerdatetime-offset: 4px;
  --inputdate-m-pickerdatetime-offset: 4px;
  --inputdate-s-pickerdatetime-offset: 4px;
  --multiselect-l-dropdownmenu-offset: 4px;
  --multiselect-l-tag-container-padding-top: 2px;
  --multiselect-l-tag-container-padding-bottom: 2px;
  --multiselect-l-spacing: 0;
  --multiselect-l-padding-left: 12px;
  --multiselect-l-padding-right: 8px;
  --multiselect-l-chevron-padding-top: 8px;
  --multiselect-m-dropdownmenu-offset: 4px;
  --multiselect-m-tag-container-padding-top: 2px;
  --multiselect-m-tag-container-padding-bottom: 2px;
  --multiselect-m-spacing: 0;
  --multiselect-m-padding-left: 8px;
  --multiselect-m-padding-right: 8px;
  --multiselect-m-chevron-padding-top: 2px;
  --multiselect-s-dropdownmenu-offset: 4px;
  --multiselect-s-tag-container-padding-top: 2px;
  --multiselect-s-tag-container-padding-bottom: 2px;
  --multiselect-s-spacing: 0;
  --multiselect-s-padding-left: 8px;
  --multiselect-s-padding-right: 8px;
  --multiselect-s-chevron-padding-top: 4px;
  --textarea-l-height: 100px;
  --textarea-l-padding-vertical: 6px;
  --textarea-m-height: 76px;
  --textarea-m-padding-vertical: 8px;
  --textarea-s-height: 56px;
  --textarea-s-padding-vertical: 4px;
  --tabitem-m-padding-top: 20px;
  --tabitem-m-padding-bottom: 20px;
  --tabitem-m-icontop-padding-top: 12px;
  --tabitem-m-icontop-padding-bottom: 12px;
  --tabitem-m-icontop-spacing: 4px;
  --tabitem-m-padding-left: 16px;
  --tabitem-m-padding-right: 16px;
  --tabitem-m-dot-size: 6px;
  --tabitem-m-dot-spacing: 6px;
  --tabitem-m-icon-spacing: 8px;
  --tabitem-m-border-radius-top-left: 6px;
  --tabitem-m-border-radius-top-right: 6px;
  --tabitem-m-border-width: 0;
  --tabitem-m-highlight-border-width: 2px;
  --tabitem-m-font: 600 16px/24px var(--font-family);
  --tabitem-m-label-padding-vertical: 0;
  --tabitem-s-dot-size: 6px;
  --tabitem-s-dot-spacing: 6px;
  --tabitem-s-padding-top: 12px;
  --tabitem-s-padding-bottom: 12px;
  --tabitem-s-icontop-padding-top: 6px;
  --tabitem-s-icontop-padding-bottom: 6px;
  --tabitem-s-icontop-spacing: 2px;
  --tabitem-s-padding-left: 12px;
  --tabitem-s-padding-right: 12px;
  --tabitem-s-icon-spacing: 8px;
  --tabitem-s-border-radius-top-left: 6px;
  --tabitem-s-border-radius-top-right: 6px;
  --tabitem-s-border-width: 0;
  --tabitem-s-highlight-border-width: 2px;
  --tabitem-s-font: 600 14px/20px var(--font-family);
  --tabitem-s-label-padding-vertical: 2px;
  --tabitem-primary-bg-color-default: rgba(255,255,255,0);
  --tabitem-primary-bg-color-hover: rgba(255,255,255,0);
  --tabitem-primary-bg-color-disabled: rgba(255,255,255,0);
  --tabitem-primary-bg-color-selected-default: rgba(${ORANGE_COLOR_RGB}, 0.1);
  --tabitem-primary-bg-color-selected-disabled: rgba(153, 153, 153, 0.1);
  --tabitem-primary-border-color-default: rgba(255,255,255,0);
  --tabitem-primary-border-color-hover: rgba(255,255,255,0);
  --tabitem-primary-border-color-disabled: rgba(255,255,255,0);
  --tabitem-primary-border-color-selected-default: rgba(255,255,255,0);
  --tabitem-primary-border-color-selected-disabled: rgba(255,255,255,0);
  --tabitem-primary-label-color-default: ${COLORS.FG.DEFAULT};
  --tabitem-primary-label-color-hover: ${COLORS.FG.DEFAULT};
  --tabitem-primary-label-color-disabled: rgba(153, 153, 153, 0.5);
  --tabitem-primary-label-color-selected-default: ${COLORS.ACCENT.DEFAULT};
  --tabitem-primary-label-color-selected-disabled: rgba(153, 153, 153, 0.5);
  --tabitem-primary-icon-color-default: ${COLORS.FG.DEFAULT};
  --tabitem-primary-icon-color-hover: ${COLORS.FG.DEFAULT};
  --tabitem-primary-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --tabitem-primary-icon-color-selected-default: ${COLORS.ACCENT.DEFAULT};
  --tabitem-primary-icon-color-selected-disabled: rgba(153, 153, 153, 0.5);
  --tabitem-primary-dot-color-default: #D91528;
  --tabitem-primary-dot-color-hover: #D91528;
  --tabitem-primary-dot-color-disabled: #D91528;
  --tabitem-primary-dot-color-selected-default: #D91528;
  --tabitem-primary-dot-color-selected-disabled: #D91528;
  --tabitem-primary-highlight-color-hover: ${COLORS.ACCENT.DEFAULT};
  --tabitem-primary-highlight-color-selected-default: ${COLORS.ACCENT.DEFAULT};
  --tabitem-primary-highlight-color-selected-disabled: rgba(153, 153, 153, 0.5);
  --tabitem-primary-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --tabitem-primary-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --tabitem-primary-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --tabitem-primary-shadow-selected-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --tabitem-primary-shadow-selected-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --tabsgroup-m-spacing: 20px;
  --tabsgroup-m-border-width: 2px;
  --tabsgroup-s-spacing: 12px;
  --tabsgroup-s-border-width: 2px;
  --tabsgroup-primary-border-color: rgba(153, 153, 153, 0.15);
  --tooltip-m-border-radius: 6px;
  --tooltip-m-border-width: 0;
  --tooltip-m-pointer-height: 8px;
  --tooltip-m-pointer-width: 14px;
  --tooltip-m-pointer-offset: 8px;
  --tooltip-m-padding-left: 12px;
  --tooltip-m-padding-right: 12px;
  --tooltip-m-padding-top: 12px;
  --tooltip-m-padding-bottom: 12px;
  --tooltip-m-content-spacing: 4px;
  --tooltip-m-closebutton-spacing: 4px;
  --tooltip-m-title-font: 600 16px/24px var(--font-family);
  --tooltip-m-subtitle-font: 400 12px/16px var(--font-family);
  --tooltip-s-pointer-height: 8px;
  --tooltip-s-pointer-width: 14px;
  --tooltip-s-pointer-offset: 8px;
  --tooltip-s-padding-left: 8px;
  --tooltip-s-padding-right: 8px;
  --tooltip-s-padding-top: 8px;
  --tooltip-s-padding-bottom: 8px;
  --tooltip-s-content-spacing: 4px;
  --tooltip-s-closebutton-spacing: 4px;
  --tooltip-s-border-radius: 6px;
  --tooltip-s-border-width: 0;
  --tooltip-s-title-font: 600 14px/20px var(--font-family);
  --tooltip-s-subtitle-font: 400 10px/12px var(--font-family);
  --tooltip-primary-bg-color: #fff;
  --tooltip-primary-border-color: rgba(255,255,255,0);
  --tooltip-primary-title-color: ${COLORS.FG.DEFAULT};
  --tooltip-primary-subtitle-color: #999999;
  --tooltip-primary-shadow: 0 0 20px 0 rgba(153, 153, 153, 0.1), 0 12px 20px 0 rgba(153, 153, 153, 0.05);
  --popover-m-border-radius: 6px;
  --popover-m-border-width: 0;
  --popover-m-pointer-height: 8px;
  --popover-m-pointer-width: 14px;
  --popover-m-pointer-offset: 8px;
  --popover-m-padding-left: ${toRem(8)};
  --popover-m-padding-right: ${toRem(8)};
  --popover-m-padding-top: ${toRem(8)};
  --popover-m-padding-bottom: ${toRem(8)};
  --popover-primary-bg-color: ${COLORS.BG.PAGE};
  --popover-primary-border-color: rgba(255,255,255,0);
  --popover-primary-shadow: none;
  --dropdownmenu-m-border-radius: 6px;
  --dropdownmenu-m-border-width: 0;
  --dropdownmenu-m-itemlist-padding-horizontal: 12px;
  --dropdownmenu-m-itemlist-padding-vertical: 8px;
  --dropdownmenu-m-itemlist-spacing: 4px;
  --dropdownmenu-m-item-border-radius: 6px;
  --dropdownmenu-m-item-padding-horizontal: 12px;
  --dropdownmenu-m-item-padding-vertical: 8px;
  --dropdownmenu-m-item-spacing: 8px;
  --dropdownmenu-m-selectionicon-padding-top: 2px;
  --dropdownmenu-m-icon-padding-top: 2px;
  --dropdownmenu-m-content-spacing: 0;
  --dropdownmenu-m-suffix-spacing: 8px;
  --dropdownmenu-m-suffix-font: 400 14px/20px var(--font-family);
  --dropdownmenu-m-itemvalue-font: 400 14px/20px var(--font-family);
  --dropdownmenu-m-hint-font: 400 12px/16px var(--font-family);
  --dropdownmenu-m-title-font: 400 12px/16px var(--font-family);
  --dropdownmenu-m-wrapper-padding-top: 0;
  --dropdownmenu-s-border-radius: 6px;
  --dropdownmenu-s-border-width: 0;
  --dropdownmenu-s-itemlist-padding-horizontal: 8px;
  --dropdownmenu-s-itemlist-padding-vertical: 8px;
  --dropdownmenu-s-itemlist-spacing: 4px;
  --dropdownmenu-s-item-border-radius: 6px;
  --dropdownmenu-s-item-padding-horizontal: 12px;
  --dropdownmenu-s-item-padding-vertical: 6px;
  --dropdownmenu-s-item-spacing: 8px;
  --dropdownmenu-s-selectionicon-padding-top: 0;
  --dropdownmenu-s-icon-padding-top: 0;
  --dropdownmenu-s-content-spacing: 2px;
  --dropdownmenu-s-suffix-spacing: 8px;
  --dropdownmenu-s-suffix-font: 400 12px/16px var(--font-family);
  --dropdownmenu-s-itemvalue-font: 400 12px/16px var(--font-family);
  --dropdownmenu-s-hint-font: 400 11.008px/16px var(--font-family);
  --dropdownmenu-s-title-font: 400 12px/16px var(--font-family);
  --dropdownmenu-s-wrapper-padding-top: 0;
  --dropdownmenu-primary-bg-color: ${COLORS.BG.PAGE};
  --dropdownmenu-primary-border-color: rgba(255,255,255,0);
  --dropdownmenu-primary-shadow: 0 0 32px 0 rgba(153, 153, 153, 0.1), 0 32px 32px 0 rgba(153, 153, 153, 0.05);
  --dropdownmenu-primary-item-bg-color-default: rgba(255,255,255,0);
  --dropdownmenu-primary-item-bg-color-hover: rgba(153, 153, 153, 0.05);
  --dropdownmenu-primary-item-bg-color-disabled: rgba(255,255,255,0);
  --dropdownmenu-primary-item-bg-color-selected-default: rgba(${ORANGE_COLOR_RGB}, 0.05);
  --dropdownmenu-primary-item-bg-color-selected-hover: rgba(${ORANGE_COLOR_RGB}, 0.1);
  --dropdownmenu-primary-item-bg-color-selected-disabled: rgba(255,255,255,0);
  --dropdownmenu-primary-itemvalue-color-default: ${COLORS.FG.DEFAULT};
  --dropdownmenu-primary-itemvalue-color-hover: ${COLORS.FG.DEFAULT};
  --dropdownmenu-primary-itemvalue-color-disabled: rgba(153, 153, 153, 0.5);
  --dropdownmenu-primary-itemvalue-color-selected-default: ${COLORS.ACCENT.DEFAULT};
  --dropdownmenu-primary-itemvalue-color-selected-hover: ${COLORS.ACCENT.DEFAULT};
  --dropdownmenu-primary-itemvalue-color-selected-disabled: rgba(153, 153, 153, 0.5);
  --dropdownmenu-primary-hint-color-default: #858fa3;
  --dropdownmenu-primary-hint-color-hover: #858fa3;
  --dropdownmenu-primary-hint-color-disabled: rgba(153, 153, 153, 0.5);
  --dropdownmenu-primary-hint-color-selected-default: ${COLORS.ACCENT.DEFAULT};
  --dropdownmenu-primary-hint-color-selected-hover: ${COLORS.ACCENT.DEFAULT};
  --dropdownmenu-primary-hint-color-selected-disabled: rgba(153, 153, 153, 0.5);
  --dropdownmenu-primary-icon-color-default: ${COLORS.FG.DEFAULT};
  --dropdownmenu-primary-icon-color-hover: ${COLORS.FG.DEFAULT};
  --dropdownmenu-primary-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --dropdownmenu-primary-icon-color-selected-default: ${COLORS.ACCENT.DEFAULT};
  --dropdownmenu-primary-icon-color-selected-hover: ${COLORS.ACCENT.DEFAULT};
  --dropdownmenu-primary-icon-color-selected-disabled: rgba(153, 153, 153, 0.5);
  --dropdownmenu-primary-selectedicon-color-default: ${COLORS.FG.DEFAULT};
  --dropdownmenu-primary-selectedicon-color-hover: ${COLORS.FG.DEFAULT};
  --dropdownmenu-primary-selectedicon-color-disabled: rgba(153, 153, 153, 0.5);
  --dropdownmenu-primary-selectedicon-color-selected-default: ${COLORS.ACCENT.DEFAULT};
  --dropdownmenu-primary-selectedicon-color-selected-hover: ${COLORS.ACCENT.DEFAULT};
  --dropdownmenu-primary-selectedicon-color-selected-disabled: rgba(153, 153, 153, 0.5);
  --dropdownmenu-primary-suffix-color-default: ${COLORS.FG.DEFAULT};
  --dropdownmenu-primary-suffix-color-hover: ${COLORS.FG.DEFAULT};
  --dropdownmenu-primary-suffix-color-disabled: rgba(153, 153, 153, 0.5);
  --dropdownmenu-primary-suffix-color-selected-default: ${COLORS.ACCENT.DEFAULT};
  --dropdownmenu-primary-suffix-color-selected-hover: ${COLORS.ACCENT.DEFAULT};
  --dropdownmenu-primary-suffix-color-selected-disabled: rgba(153, 153, 153, 0.5);
  --dropdownmenu-primary-title-color: #858fa3;
  --segmentedcontrol-l-height: 48px;
  --segmentedcontrol-l-border-radius: 24px;
  --segmentedcontrol-l-border-width: 0;
  --segmentedcontrol-l-padding-horizontal: 6px;
  --segmentedcontrol-l-padding-vertical: 6px;
  --segmentedcontrol-l-spacing: 0;
  --segmentedcontrol-l-segment-border-radius: 24px;
  --segmentedcontrol-l-segment-border-width: 0;
  --segmentedcontrol-l-segment-padding-horizontal: 16px;
  --segmentedcontrol-l-segment-spacing: 8px;
  --segmentedcontrol-l-segment-font: 600 16px/24px var(--font-family);
  --segmentedcontrol-m-height: 36px;
  --segmentedcontrol-m-padding-horizontal: 4px;
  --segmentedcontrol-m-padding-vertical: 4px;
  --segmentedcontrol-m-spacing: 0;
  --segmentedcontrol-m-border-radius: 6px; //CHANGED
  --segmentedcontrol-m-border-width: 0;
  --segmentedcontrol-m-segment-padding-horizontal: 12px;
  --segmentedcontrol-m-segment-spacing: 6px;
  --segmentedcontrol-m-segment-border-radius: 6px; //CHANGED
  --segmentedcontrol-m-segment-border-width: 0;
  --segmentedcontrol-m-segment-font: 600 14px/20px var(--font-family);
  --segmentedcontrol-s-height: 24px;
  --segmentedcontrol-s-padding-horizontal: 2px;
  --segmentedcontrol-s-padding-vertical: 2px;
  --segmentedcontrol-s-spacing: 0;
  --segmentedcontrol-s-border-radius: 24px;
  --segmentedcontrol-s-border-width: 0;
  --segmentedcontrol-s-segment-padding-horizontal: 8px;
  --segmentedcontrol-s-segment-spacing: 4px;
  --segmentedcontrol-s-segment-border-radius: 24px;
  --segmentedcontrol-s-segment-border-width: 0;
  --segmentedcontrol-s-segment-font: 600 12px/16px var(--font-family);
  --segmentedcontrol-primary-bg-color: rgba(${ORANGE_COLOR_RGB}, 0.05);
  --segmentedcontrol-primary-border-color: rgba(255,255,255,0);
  --segmentedcontrol-primary-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --segmentedcontrol-primary-segment-bg-color-default: rgba(255,255,255,0);
  --segmentedcontrol-primary-segment-bg-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.1);
  --segmentedcontrol-primary-segment-bg-color-disabled: rgba(255,255,255,0);
  --segmentedcontrol-primary-segment-bg-color-selected-default: ${COLORS.ACCENT.DEFAULT};
  --segmentedcontrol-primary-segment-bg-color-selected-disabled: rgba(153, 153, 153, 0.1);
  --segmentedcontrol-primary-segment-border-color-default: rgba(255,255,255,0);
  --segmentedcontrol-primary-segment-border-color-hover: rgba(255,255,255,0);
  --segmentedcontrol-primary-segment-border-color-disabled: rgba(255,255,255,0);
  --segmentedcontrol-primary-segment-border-color-selected-default: rgba(255,255,255,0);
  --segmentedcontrol-primary-segment-border-color-selected-disabled: rgba(255,255,255,0);
  --segmentedcontrol-primary-segment-label-color-default: ${COLORS.ACCENT.DEFAULT};
  --segmentedcontrol-primary-segment-label-color-hover: ${COLORS.ACCENT.DEFAULT};
  --segmentedcontrol-primary-segment-label-color-disabled: rgba(153, 153, 153, 0.5);
  --segmentedcontrol-primary-segment-label-color-selected-default: #fff;
  --segmentedcontrol-primary-segment-label-color-selected-disabled: rgba(153, 153, 153, 0.5);
  --segmentedcontrol-primary-segment-icon-color-default: ${COLORS.ACCENT.DEFAULT};
  --segmentedcontrol-primary-segment-icon-color-hover: ${COLORS.ACCENT.DEFAULT};
  --segmentedcontrol-primary-segment-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --segmentedcontrol-primary-segment-icon-color-selected-default: #fff;
  --segmentedcontrol-primary-segment-icon-color-selected-disabled: rgba(153, 153, 153, 0.5);
  --segmentedcontrol-primary-segment-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --segmentedcontrol-primary-segment-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --segmentedcontrol-primary-segment-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --segmentedcontrol-primary-segment-shadow-selected-default: 0 0 1px 0 rgba(153, 153, 153, 0.1), 0 2px 2px 0 rgba(153, 153, 153, 0.2);
  --segmentedcontrol-primary-segment-shadow-selected-disabled: 0 0 1px 0 rgba(153, 153, 153, 0.1), 0 2px 2px 0 rgba(153, 153, 153, 0.2);
  --segmentedcontrol-secondary-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --segmentedcontrol-secondary-bg-color: light-dark(rgba(88, 93, 105, 0.1), ${COLORS.BG.SURFACE3});
  --segmentedcontrol-secondary-border-color: rgba(255,255,255,0);
  --segmentedcontrol-secondary-segment-bg-color-default: rgba(255,255,255,0);
  --segmentedcontrol-secondary-segment-bg-color-hover: light-dark(rgba(153, 153, 153, 0.1), rgba(153, 153, 153, 0.1));
  --segmentedcontrol-secondary-segment-bg-color-disabled: rgba(255,255,255,0);
  --segmentedcontrol-secondary-segment-bg-color-selected-default: light-dark(#fff, ${COLORS.BG.SURFACE2});
  --segmentedcontrol-secondary-segment-bg-color-selected-disabled: light-dark(rgba(153, 153, 153, 0.1), rgba(153, 153, 153, 0.1));
  --segmentedcontrol-secondary-segment-border-color-default: rgba(255,255,255,0);
  --segmentedcontrol-secondary-segment-border-color-hover: rgba(255,255,255,0);
  --segmentedcontrol-secondary-segment-border-color-disabled: rgba(255,255,255,0);
  --segmentedcontrol-secondary-segment-border-color-selected-default: rgba(255,255,255,0);
  --segmentedcontrol-secondary-segment-border-color-selected-disabled: rgba(255,255,255,0);
  --segmentedcontrol-secondary-segment-label-color-default: light-dark(#999999, ${COLORS.FG.DEFAULT});
  --segmentedcontrol-secondary-segment-label-color-hover: light-dark(#999999, ${COLORS.FG.DEFAULT});
  --segmentedcontrol-secondary-segment-label-color-disabled: rgba(153, 153, 153, 0.5);
  --segmentedcontrol-secondary-segment-label-color-selected-default: light-dark(rgb(16, 24, 40), ${COLORS.FG.DEFAULT});
  --segmentedcontrol-secondary-segment-label-color-selected-disabled: rgba(153, 153, 153, 0.5);
  --segmentedcontrol-secondary-segment-icon-color-default: light-dark(#999999, ${COLORS.FG.DEFAULT});
  --segmentedcontrol-secondary-segment-icon-color-hover: light-dark(#999999, ${COLORS.FG.DEFAULT});
  --segmentedcontrol-secondary-segment-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --segmentedcontrol-secondary-segment-icon-color-selected-default: ${COLORS.ACCENT.DEFAULT};
  --segmentedcontrol-secondary-segment-icon-color-selected-disabled: rgba(153, 153, 153, 0.5);
  --segmentedcontrol-secondary-segment-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --segmentedcontrol-secondary-segment-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --segmentedcontrol-secondary-segment-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --segmentedcontrol-secondary-segment-shadow-selected-default: 0 0 1px 0 rgba(153, 153, 153, 0.1), 0 2px 2px 0 rgba(153, 153, 153, 0.2);
  --segmentedcontrol-secondary-segment-shadow-selected-disabled: 0 0 1px 0 rgba(153, 153, 153, 0.1), 0 2px 2px 0 rgba(153, 153, 153, 0.2);
  --breadcrumbs-s-item-padding-vertical: 4px;
  --breadcrumbs-s-item-font: 600 12px/16px var(--font-family);
  --breadcrumbs-s-divider-height: 3px;
  --breadcrumbs-s-dividermenu-height: 24px;
  --breadcrumbs-s-dividermenu-border-width: 0;
  --breadcrumbs-s-dividermenu-border-radius: 4px;
  --breadcrumbs-s-spacing-horizontal: 8px;
  --breadcrumbs-s-spacing-vertical: 4px;
  --breadcrumbs-primary-item-label-color-default: ${COLORS.FG.DEFAULT};
  --breadcrumbs-primary-item-label-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --breadcrumbs-primary-item-label-color-active: #858fa3;
  --breadcrumbs-primary-divider-icon-color: ${COLORS.FG.DEFAULT};
  --breadcrumbs-primary-dividermenu-bg-color-default: rgba(255,255,255,0);
  --breadcrumbs-primary-dividermenu-bg-color-hover: rgba(255,255,255,0);
  --breadcrumbs-primary-dividermenu-bg-color-focus: #f6f6f8;
  --breadcrumbs-primary-dividermenu-icon-color-default: #858fa3;
  --breadcrumbs-primary-dividermenu-icon-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --breadcrumbs-primary-dividermenu-icon-color-focus: ${COLORS.FG.DEFAULT};
  --breadcrumbs-primary-dividermenu-border-color-default: rgba(255,255,255,0);
  --breadcrumbs-primary-dividermenu-border-color-hover: rgba(255,255,255,0);
  --breadcrumbs-primary-dividermenu-border-color-focus: rgba(255,255,255,0);
  --breadcrumbs-primary-dividermenu-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --breadcrumbs-primary-dividermenu-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --breadcrumbs-primary-dividermenu-shadow-focus: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --floatingactionbutton-l-height: 48px;
  --floatingactionbutton-l-padding-horizontal: 20px;
  --floatingactionbutton-l-spacing: 4px;
  --floatingactionbutton-l-label-padding-horizontal: 4px;
  --floatingactionbutton-l-border-width: 2px;
  --floatingactionbutton-l-border-radius: 6px;
  --floatingactionbutton-l-font: 600 16px/24px var(--font-family);
  --floatingactionbutton-l-menu-offset: 12px;
  --floatingactionbutton-l-menu-spacing: 8px;
  --floatingactionbutton-l-menuitem-height: 48px;
  --floatingactionbutton-l-menuitem-padding-horizontal: 12px;
  --floatingactionbutton-l-menuitem-spacing: 4px;
  --floatingactionbutton-l-menuitem-border-width: 0;
  --floatingactionbutton-l-menuitem-border-radius: 6px;
  --floatingactionbutton-l-menuitem-font: 400 14px/20px var(--font-family);
  --floatingactionbutton-primary-bg-color-default: ${COLORS.ACCENT.DEFAULT};
  --floatingactionbutton-primary-bg-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --floatingactionbutton-primary-bg-color-active: ${COLORS.ACCENT.DEFAULT};
  --floatingactionbutton-primary-border-color-default: rgba(255,255,255,0);
  --floatingactionbutton-primary-border-color-hover: rgba(255,255,255,0);
  --floatingactionbutton-primary-border-color-active: rgba(255,255,255,0);
  --floatingactionbutton-primary-icon-color-default: #fff;
  --floatingactionbutton-primary-icon-color-hover: #fff;
  --floatingactionbutton-primary-icon-color-active: #fff;
  --floatingactionbutton-primary-label-color-default: #fff;
  --floatingactionbutton-primary-label-color-hover: #fff;
  --floatingactionbutton-primary-label-color-active: #fff;
  --floatingactionbutton-primary-shadow-default: 0 0 20px 0 rgba(153, 153, 153, 0.1), 0 12px 20px 0 rgba(153, 153, 153, 0.05);
  --floatingactionbutton-primary-shadow-hover: 0 0 20px 0 rgba(153, 153, 153, 0.1), 0 12px 20px 0 rgba(153, 153, 153, 0.05);
  --floatingactionbutton-primary-shadow-active: 0 0 20px 0 rgba(153, 153, 153, 0.1), 0 12px 20px 0 rgba(153, 153, 153, 0.05);
  --floatingactionbutton-primary-menuitem-bg-color-default: #fff;
  --floatingactionbutton-primary-menuitem-bg-color-hover: #fff;
  --floatingactionbutton-primary-menuitem-bg-color-active: #fff;
  --floatingactionbutton-primary-menuitem-border-color-default: rgba(255,255,255,0);
  --floatingactionbutton-primary-menuitem-border-color-hover: rgba(255,255,255,0);
  --floatingactionbutton-primary-menuitem-border-color-active: rgba(255,255,255,0);
  --floatingactionbutton-primary-menuitem-label-color-default: ${COLORS.FG.DEFAULT};
  --floatingactionbutton-primary-menuitem-label-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --floatingactionbutton-primary-menuitem-label-color-active: ${COLORS.ACCENT.DEFAULT};
  --floatingactionbutton-primary-menuitem-icon-color-default: ${COLORS.FG.DEFAULT};
  --floatingactionbutton-primary-menuitem-icon-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --floatingactionbutton-primary-menuitem-icon-color-active: ${COLORS.ACCENT.DEFAULT};
  --floatingactionbutton-primary-menuitem-shadow-default: 0 0 32px 0 rgba(153, 153, 153, 0.1), 0 32px 32px 0 rgba(153, 153, 153, 0.05);
  --floatingactionbutton-primary-menuitem-shadow-hover: 0 0 32px 0 rgba(153, 153, 153, 0.1), 0 32px 32px 0 rgba(153, 153, 153, 0.05);
  --floatingactionbutton-primary-menuitem-shadow-active: 0 0 32px 0 rgba(153, 153, 153, 0.1), 0 32px 32px 0 rgba(153, 153, 153, 0.05);
  --floatingactionbutton-secondary-shadow-default: 0 0 20px 0 rgba(153, 153, 153, 0.1), 0 12px 20px 0 rgba(153, 153, 153, 0.05);
  --floatingactionbutton-secondary-shadow-hover: 0 0 20px 0 rgba(153, 153, 153, 0.1), 0 12px 20px 0 rgba(153, 153, 153, 0.05);
  --floatingactionbutton-secondary-shadow-active: 0 0 20px 0 rgba(153, 153, 153, 0.1), 0 12px 20px 0 rgba(153, 153, 153, 0.05);
  --floatingactionbutton-secondary-menuitem-shadow-default: 0 0 32px 0 rgba(153, 153, 153, 0.1), 0 32px 32px 0 rgba(153, 153, 153, 0.05);
  --floatingactionbutton-secondary-menuitem-shadow-hover: 0 0 32px 0 rgba(153, 153, 153, 0.1), 0 32px 32px 0 rgba(153, 153, 153, 0.05);
  --floatingactionbutton-secondary-menuitem-shadow-active: 0 0 32px 0 rgba(153, 153, 153, 0.1), 0 32px 32px 0 rgba(153, 153, 153, 0.05);
  --floatingactionbutton-secondary-menuitem-bg-color-default: #fff;
  --floatingactionbutton-secondary-menuitem-bg-color-hover: #fff;
  --floatingactionbutton-secondary-menuitem-bg-color-active: #fff;
  --floatingactionbutton-secondary-menuitem-border-color-default: rgba(255,255,255,0);
  --floatingactionbutton-secondary-menuitem-border-color-hover: rgba(255,255,255,0);
  --floatingactionbutton-secondary-menuitem-border-color-active: rgba(255,255,255,0);
  --floatingactionbutton-secondary-menuitem-label-color-default: ${COLORS.FG.DEFAULT};
  --floatingactionbutton-secondary-menuitem-label-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --floatingactionbutton-secondary-menuitem-label-color-active: ${COLORS.ACCENT.DEFAULT};
  --floatingactionbutton-secondary-menuitem-icon-color-default: ${COLORS.FG.DEFAULT};
  --floatingactionbutton-secondary-menuitem-icon-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --floatingactionbutton-secondary-menuitem-icon-color-active: ${COLORS.ACCENT.DEFAULT};
  --floatingactionbutton-secondary-bg-color-default: #fff;
  --floatingactionbutton-secondary-bg-color-hover: rgba(153, 153, 153, 0.2);
  --floatingactionbutton-secondary-bg-color-active: rgba(153, 153, 153, 0.3);
  --floatingactionbutton-secondary-border-color-default: rgba(255,255,255,0);
  --floatingactionbutton-secondary-border-color-hover: rgba(255,255,255,0);
  --floatingactionbutton-secondary-border-color-active: rgba(255,255,255,0);
  --floatingactionbutton-secondary-icon-color-default: ${COLORS.FG.DEFAULT};
  --floatingactionbutton-secondary-icon-color-hover: ${COLORS.FG.DEFAULT};
  --floatingactionbutton-secondary-icon-color-active: ${COLORS.FG.DEFAULT};
  --floatingactionbutton-secondary-label-color-default: ${COLORS.FG.DEFAULT};
  --floatingactionbutton-secondary-label-color-hover: ${COLORS.FG.DEFAULT};
  --floatingactionbutton-secondary-label-color-active: ${COLORS.FG.DEFAULT};
  --stepper-l-height: 48px;
  --stepper-l-divider-height: 24px;
  --stepper-l-border-width: 2px;
  --stepper-l-spacing: 4px;
  --stepper-l-border-radius: 6px;
  --stepper-l-button-border-radius-inside: 0;
  --stepper-l-button-border-radius-outside: 6px;
  --stepper-l-button-border-width: 2px;
  --stepper-l-font: 600 16px/24px var(--font-family);
  --stepper-m-height: 36px;
  --stepper-m-divider-height: 16px;
  --stepper-m-spacing: 2px;
  --stepper-m-border-radius: 6px;
  --stepper-m-button-border-radius-inside: 0;
  --stepper-m-button-border-radius-outside: 6px;
  --stepper-m-button-border-width: 2px;
  --stepper-m-border-width: 2px;
  --stepper-m-font: 600 14px/20px var(--font-family);
  --stepper-primary-accent-bg-color-default: ${COLORS.ACCENT.DEFAULT};
  --stepper-primary-accent-bg-color-disabled: rgba(153, 153, 153, 0.1);
  --stepper-primary-accent-border-color-default: rgba(255,255,255,0);
  --stepper-primary-accent-border-color-disabled: rgba(255,255,255,0);
  --stepper-primary-accent-label-color-default: #fff;
  --stepper-primary-accent-label-color-disabled: rgba(153, 153, 153, 0.5);
  --stepper-primary-accent-button-bg-color-default: rgba(255,255,255,0);
  --stepper-primary-accent-button-bg-color-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --stepper-primary-accent-button-bg-color-active: ${COLORS.ACCENT.DEFAULT};
  --stepper-primary-accent-button-bg-color-disabled: rgba(255,255,255,0);
  --stepper-primary-accent-button-border-color-default: rgba(255,255,255,0);
  --stepper-primary-accent-button-border-color-hover: rgba(255,255,255,0);
  --stepper-primary-accent-button-border-color-active: rgba(255,255,255,0);
  --stepper-primary-accent-button-border-color-disabled: rgba(255,255,255,0);
  --stepper-primary-accent-button-icon-color-default: #fff;
  --stepper-primary-accent-button-icon-color-hover: #fff;
  --stepper-primary-accent-button-icon-color-active: #fff;
  --stepper-primary-accent-button-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --stepper-primary-accent-button-icon-iconsingle-color: #80aaff;
  --stepper-primary-accent-button-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --stepper-primary-accent-button-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --stepper-primary-accent-button-shadow-active: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --stepper-primary-accent-button-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --stepper-primary-accent-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --stepper-primary-accent-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --stepper-primary-accent-divider-border-color-default: ${COLORS.ACCENT.DEFAULT};
  --stepper-primary-accent-divider-border-color-disabled: rgba(153, 153, 153, 0.5);
  --stepper-primary-neutral-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --stepper-primary-neutral-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --stepper-primary-neutral-button-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --stepper-primary-neutral-button-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --stepper-primary-neutral-button-shadow-active: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --stepper-primary-neutral-button-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --stepper-primary-neutral-button-bg-color-default: rgba(255,255,255,0);
  --stepper-primary-neutral-button-bg-color-hover: rgba(153, 153, 153, 0.2);
  --stepper-primary-neutral-button-bg-color-active: rgba(153, 153, 153, 0.3);
  --stepper-primary-neutral-button-bg-color-disabled: rgba(255,255,255,0);
  --stepper-primary-neutral-button-border-color-default: rgba(255,255,255,0);
  --stepper-primary-neutral-button-border-color-hover: rgba(255,255,255,0);
  --stepper-primary-neutral-button-border-color-active: rgba(255,255,255,0);
  --stepper-primary-neutral-button-border-color-disabled: rgba(255,255,255,0);
  --stepper-primary-neutral-button-icon-color-default: #999999;
  --stepper-primary-neutral-button-icon-color-hover: #999999;
  --stepper-primary-neutral-button-icon-color-active: #999999;
  --stepper-primary-neutral-button-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --stepper-primary-neutral-button-icon-iconsingle-color: rgba(153, 153, 153, 0.5);
  --stepper-primary-neutral-bg-color-default: rgba(153, 153, 153, 0.1);
  --stepper-primary-neutral-bg-color-disabled: rgba(153, 153, 153, 0.1);
  --stepper-primary-neutral-border-color-default: rgba(255,255,255,0);
  --stepper-primary-neutral-border-color-disabled: rgba(255,255,255,0);
  --stepper-primary-neutral-label-color-default: ${COLORS.FG.DEFAULT};
  --stepper-primary-neutral-label-color-disabled: rgba(153, 153, 153, 0.5);
  --stepper-primary-neutral-divider-border-color-default: rgba(153, 153, 153, 0.15);
  --stepper-primary-neutral-divider-border-color-disabled: rgba(153, 153, 153, 0.5);
  --slider-m-track-height-default: 4px;
  --slider-m-track-border-radius: 3px;
  --slider-m-highlighttrack-border-radius: 3px;
  --slider-m-highlighttrack-height-default: 4px;
  --slider-m-handle-height-default: 16px;
  --slider-m-handle-height-hover: 20px;
  --slider-m-handle-border-width: 0;
  --slider-m-handle-border-radius: 9999px;
  --slider-m-tooltip-offset: 12px;
  --slider-m-tooltip-border-radius: 6px;
  --slider-m-tooltip-border-width: 0;
  --slider-m-tooltip-arrow-height: 8px;
  --slider-m-tooltip-arrow-width: 14px;
  --slider-m-tooltip-padding-left: 8px;
  --slider-m-tooltip-padding-right: 8px;
  --slider-m-tooltip-padding-top: 4px;
  --slider-m-tooltip-padding-bottom: 4px;
  --slider-m-tooltip-font: 600 14px/20px var(--font-family);
  --slider-m-spacing: 12px;
  --slider-m-label-spacing: 8px;
  --slider-m-label-font: 400 14px/20px var(--font-family);
  --slider-m-counter-font: 600 13.008px/20px var(--font-family);
  --slider-m-marks-font: 400 10px/12px var(--font-family);
  --slider-primary-track-bg-color-default: rgba(153, 153, 153, 0.1);
  --slider-primary-track-bg-color-hover: rgba(153, 153, 153, 0.1);
  --slider-primary-track-bg-color-disabled: rgba(153, 153, 153, 0.1);
  --slider-primary-track-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --slider-primary-track-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --slider-primary-track-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --slider-primary-highlighttrack-bg-color-default: ${COLORS.ACCENT.DEFAULT};
  --slider-primary-highlighttrack-bg-color-hover: ${COLORS.ACCENT.DEFAULT};
  --slider-primary-highlighttrack-bg-color-disabled: rgba(153, 153, 153, 0.2);
  --slider-primary-highlighttrack-steps-color-default: #80aaff;
  --slider-primary-highlighttrack-steps-color-hover: #80aaff;
  --slider-primary-handle-bg-color-default: ${COLORS.ACCENT.DEFAULT};
  --slider-primary-handle-bg-color-hover: ${COLORS.ACCENT.DEFAULT};
  --slider-primary-handle-bg-color-disabled: #d0d4dc;
  --slider-primary-handle-shadow-default: 0 0 1px 0 rgba(153, 153, 153, 0.1), 0 2px 2px 0 rgba(153, 153, 153, 0.2);
  --slider-primary-handle-shadow-hover: 0 0 1px 0 rgba(153, 153, 153, 0.1), 0 2px 2px 0 rgba(153, 153, 153, 0.2);
  --slider-primary-handle-shadow-disabled: 0 0 1px 0 rgba(153, 153, 153, 0.1), 0 2px 2px 0 rgba(153, 153, 153, 0.2);
  --slider-primary-handle-border-color-default: rgba(255,255,255,0);
  --slider-primary-handle-border-color-hover: rgba(255,255,255,0);
  --slider-primary-handle-border-color-disabled: rgba(255,255,255,0);
  --slider-primary-label-color-default: ${COLORS.FG.DEFAULT};
  --slider-primary-label-color-disabled: rgba(153, 153, 153, 0.5);
  --slider-primary-counter-color-default: ${COLORS.FG.DEFAULT};
  --slider-primary-counter-color-disabled: rgba(153, 153, 153, 0.5);
  --slider-primary-marks-color-default: #858fa3;
  --slider-primary-marks-color-disabled: rgba(153, 153, 153, 0.5);
  --slider-primary-tracksteps-color-default: #a2a9b8;
  --slider-primary-tracksteps-color-hover: #a2a9b8;
  --slider-primary-tooltip-border-color-default: rgba(255,255,255,0);
  --slider-primary-tooltip-border-color-disabled: rgba(255,255,255,0);
  --slider-primary-tooltip-bg-color-default: #fff;
  --slider-primary-tooltip-bg-color-disabled: #fff;
  --slider-primary-tooltip-shadow-default: 0 0 20px 0 rgba(153, 153, 153, 0.1), 0 12px 20px 0 rgba(153, 153, 153, 0.05);
  --slider-primary-tooltip-shadow-disabled: 0 0 20px 0 rgba(153, 153, 153, 0.1), 0 12px 20px 0 rgba(153, 153, 153, 0.05);
  --slider-primary-tooltip-title-color-default: ${COLORS.FG.DEFAULT};
  --slider-primary-tooltip-title-color-disabled: rgba(153, 153, 153, 0.5);
  --toastnotification-m-border-width: 0;
  --toastnotification-m-border-radius: 6px;
  --toastnotification-m-padding-top: 16px;
  --toastnotification-m-padding-bottom: 16px;
  --toastnotification-m-padding-left: 12px;
  --toastnotification-m-padding-right: 12px;
  --toastnotification-m-iconcontainer-border-width: 0;
  --toastnotification-m-iconcontainer-border-radius: 6px;
  --toastnotification-m-iconcontainer-padding-top: 12px;
  --toastnotification-m-iconcontainer-padding-bottom: 12px;
  --toastnotification-m-iconcontainer-padding-left: 12px;
  --toastnotification-m-iconcontainer-padding-right: 12px;
  --toastnotification-m-content-padding-top: 0;
  --toastnotification-m-content-padding-bottom: 0;
  --toastnotification-m-content-padding-left: 12px;
  --toastnotification-m-content-padding-right: 0;
  --toastnotification-m-header-spacing: 4px;
  --toastnotification-m-header-font: 800 14px/20px var(--font-family);
  --toastnotification-m-text-spacing: 12px;
  --toastnotification-m-action-buttons-spacing: 16px;
  --toastnotification-m-buttons-spacing: 12px;
  --toastnotification-m-subtitle-font: 400 14px/20px var(--font-family);
  --toastnotification-primary-info-bg-color: #fff;
  --toastnotification-primary-info-border-color: rgba(255,255,255,0);
  --toastnotification-primary-info-header-color: ${COLORS.FG.DEFAULT};
  --toastnotification-primary-info-subtitle-color: #999999;
  --toastnotification-primary-info-iconcontainer-color: rgba(25, 152, 255, 0.1);
  --toastnotification-primary-info-iconcontainer-border-color: rgba(255,255,255,0);
  --toastnotification-primary-info-iconcontainer-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --toastnotification-primary-info-icon-color: #1998FF;
  --toastnotification-primary-info-shadow: 0 0 20px 0 rgba(153, 153, 153, 0.1), 0 12px 20px 0 rgba(153, 153, 153, 0.05);
  --toastnotification-primary-success-bg-color: #fff;
  --toastnotification-primary-success-border-color: rgba(255,255,255,0);
  --toastnotification-primary-success-header-color: ${COLORS.FG.DEFAULT};
  --toastnotification-primary-success-subtitle-color: #999999;
  --toastnotification-primary-success-iconcontainer-color: rgba(1, 159, 60, 0.1);
  --toastnotification-primary-success-iconcontainer-border-color: rgba(255,255,255,0);
  --toastnotification-primary-success-iconcontainer-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --toastnotification-primary-success-icon-color: #019F3C;
  --toastnotification-primary-success-shadow: 0 0 20px 0 rgba(153, 153, 153, 0.1), 0 12px 20px 0 rgba(153, 153, 153, 0.05);
  --toastnotification-primary-warning-bg-color: #fff;
  --toastnotification-primary-warning-border-color: rgba(255,255,255,0);
  --toastnotification-primary-warning-header-color: ${COLORS.FG.DEFAULT};
  --toastnotification-primary-warning-subtitle-color: #999999;
  --toastnotification-primary-warning-iconcontainer-color: rgba(242, 145, 0, 0.1);
  --toastnotification-primary-warning-iconcontainer-border-color: rgba(255,255,255,0);
  --toastnotification-primary-warning-iconcontainer-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --toastnotification-primary-warning-icon-color: #F29100;
  --toastnotification-primary-warning-shadow: 0 0 20px 0 rgba(153, 153, 153, 0.1), 0 12px 20px 0 rgba(153, 153, 153, 0.05);
  --toastnotification-primary-error-bg-color: #fff;
  --toastnotification-primary-error-border-color: rgba(255,255,255,0);
  --toastnotification-primary-error-header-color: ${COLORS.FG.DEFAULT};
  --toastnotification-primary-error-subtitle-color: #999999;
  --toastnotification-primary-error-iconcontainer-color: rgba(217, 21, 40, 0.1);
  --toastnotification-primary-error-iconcontainer-border-color: rgba(255,255,255,0);
  --toastnotification-primary-error-iconcontainer-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --toastnotification-primary-error-icon-color: #D91528;
  --toastnotification-primary-error-shadow: 0 0 20px 0 rgba(153, 153, 153, 0.1), 0 12px 20px 0 rgba(153, 153, 153, 0.05);
  --customtoastnotification-m-border-width: 0;
  --customtoastnotification-m-border-radius: 6px;
  --customtoastnotification-primary-bg-color: #fff;
  --customtoastnotification-primary-border-color: rgba(255,255,255,0);
  --customtoastnotification-primary-shadow: 0 0 20px 0 rgba(153, 153, 153, 0.1), 0 12px 20px 0 rgba(153, 153, 153, 0.05);
  --inlinenotification-primary-info-bg-color: #fff;
  --inlinenotification-primary-info-border-color: #8cccff;
  --inlinenotification-primary-info-header-color: ${COLORS.FG.DEFAULT};
  --inlinenotification-primary-info-subtitle-color: #999999;
  --inlinenotification-primary-info-iconcontainer-color: rgba(25, 152, 255, 0.1);
  --inlinenotification-primary-info-iconcontainer-border-color: rgba(255,255,255,0);
  --inlinenotification-primary-info-iconcontainer-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --inlinenotification-primary-info-icon-color: #1998FF;
  --inlinenotification-primary-info-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --inlinenotification-primary-success-bg-color: #fff;
  --inlinenotification-primary-success-border-color: #80cf9e;
  --inlinenotification-primary-success-header-color: ${COLORS.FG.DEFAULT};
  --inlinenotification-primary-success-subtitle-color: #999999;
  --inlinenotification-primary-success-iconcontainer-color: rgba(1, 159, 60, 0.1);
  --inlinenotification-primary-success-iconcontainer-border-color: rgba(255,255,255,0);
  --inlinenotification-primary-success-iconcontainer-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --inlinenotification-primary-success-icon-color: #019F3C;
  --inlinenotification-primary-success-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --inlinenotification-primary-warning-bg-color: #fff;
  --inlinenotification-primary-warning-border-color: #f9c880;
  --inlinenotification-primary-warning-header-color: ${COLORS.FG.DEFAULT};
  --inlinenotification-primary-warning-subtitle-color: #999999;
  --inlinenotification-primary-warning-iconcontainer-color: rgba(242, 145, 0, 0.1);
  --inlinenotification-primary-warning-iconcontainer-border-color: rgba(255,255,255,0);
  --inlinenotification-primary-warning-iconcontainer-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --inlinenotification-primary-warning-icon-color: #F29100;
  --inlinenotification-primary-warning-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --inlinenotification-primary-error-bg-color: #fff;
  --inlinenotification-primary-error-border-color: #ec8a93;
  --inlinenotification-primary-error-header-color: ${COLORS.FG.DEFAULT};
  --inlinenotification-primary-error-subtitle-color: #999999;
  --inlinenotification-primary-error-iconcontainer-color: rgba(217, 21, 40, 0.1);
  --inlinenotification-primary-error-iconcontainer-border-color: rgba(255,255,255,0);
  --inlinenotification-primary-error-iconcontainer-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --inlinenotification-primary-error-icon-color: #D91528;
  --inlinenotification-primary-error-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --inlinenotification-m-border-width: 2px;
  --inlinenotification-m-border-radius: 6px;
  --inlinenotification-m-padding-top: 0;
  --inlinenotification-m-padding-bottom: 0;
  --inlinenotification-m-padding-left: 0;
  --inlinenotification-m-padding-right: 0;
  --inlinenotification-m-iconcontainer-border-width: 0;
  --inlinenotification-m-iconcontainer-border-radius: 0;
  --inlinenotification-m-iconcontainer-padding-top: 16px;
  --inlinenotification-m-iconcontainer-padding-bottom: 16px;
  --inlinenotification-m-iconcontainer-padding-left: 12px;
  --inlinenotification-m-iconcontainer-padding-right: 12px;
  --inlinenotification-m-content-padding-top: 16px;
  --inlinenotification-m-content-padding-bottom: 16px;
  --inlinenotification-m-content-padding-left: 16px;
  --inlinenotification-m-content-padding-right: 16px;
  --inlinenotification-m-header-spacing: 4px;
  --inlinenotification-m-header-font: 800 14px/20px var(--font-family);
  --inlinenotification-m-text-spacing: 12px;
  --inlinenotification-m-action-buttons-spacing: 16px;
  --inlinenotification-m-buttons-spacing: 8px;
  --inlinenotification-m-subtitle-font: 400 14px/20px var(--font-family);
  --custominlinenotification-primary-bg-color: #fff;
  --custominlinenotification-primary-border-color: #858fa3;
  --custominlinenotification-primary-shadow: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --custominlinenotification-m-border-width: 2px;
  --custominlinenotification-m-border-radius: 6px;
  --switch-s-height: 24px;
  --switch-s-width: 40px;
  --switch-s-padding-horizontal: 1px;
  --switch-s-track-height: 20px;
  --switch-s-track-padding-horizontal: 2px;
  --switch-s-track-border-radius: 9999px;
  --switch-s-track-border-width: 2px;
  --switch-s-knob-height: 16px;
  --switch-s-knob-width: 16px;
  --switch-s-knob-border-radius: 9999px;
  --switch-s-knob-border-width: 2px;
  --switch-s-spacing: 8px;
  --switch-s-label-padding-vertical: 0;
  --switch-s-font: 400 16px/24px var(--font-family);
  --switch-xs-height: 20px;
  --switch-xs-width: 32px;
  --switch-xs-track-height: 16px;
  --switch-xs-track-padding-horizontal: 2px;
  --switch-xs-track-border-radius: 9999px;
  --switch-xs-track-border-width: 2px;
  --switch-xs-knob-height: 12px;
  --switch-xs-knob-width: 12px;
  --switch-xs-knob-border-radius: 9999px;
  --switch-xs-knob-border-width: 2px;
  --switch-xs-padding-horizontal: 1px;
  --switch-xs-spacing: 8px;
  --switch-xs-label-padding-vertical: 0;
  --switch-xs-font: 400 14px/20px var(--font-family);
  --switch-primary-track-bg-color-default: rgba(153, 153, 153, 0.25);
  --switch-primary-track-bg-color-hover: rgba(153, 153, 153, 0.5);
  --switch-primary-track-bg-color-disabled: rgba(153, 153, 153, 0.1);
  --switch-primary-track-bg-color-checked-default: ${COLORS.ACCENT.DEFAULT};
  --switch-primary-track-bg-color-checked-hover: rgba(${ORANGE_COLOR_RGB}, 0.7);
  --switch-primary-track-bg-color-checked-disabled: rgba(${ORANGE_COLOR_RGB}, 0.1);
  --switch-primary-track-border-color-default: rgba(255,255,255,0);
  --switch-primary-track-border-color-hover: rgba(255,255,255,0);
  --switch-primary-track-border-color-disabled: rgba(255,255,255,0);
  --switch-primary-track-border-color-checked-default: rgba(255,255,255,0);
  --switch-primary-track-border-color-checked-hover: rgba(255,255,255,0);
  --switch-primary-track-border-color-checked-disabled: rgba(255,255,255,0);
  --switch-primary-track-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --switch-primary-track-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --switch-primary-track-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --switch-primary-track-shadow-checked-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --switch-primary-track-shadow-checked-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --switch-primary-track-shadow-checked-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --switch-primary-label-color-default: ${COLORS.FG.DEFAULT};
  --switch-primary-label-color-hover: ${COLORS.FG.DEFAULT};
  --switch-primary-label-color-disabled: rgba(153, 153, 153, 0.5);
  --switch-primary-label-color-checked-default: ${COLORS.FG.DEFAULT};
  --switch-primary-label-color-checked-hover: ${COLORS.FG.DEFAULT};
  --switch-primary-label-color-checked-disabled: rgba(153, 153, 153, 0.5);
  --switch-primary-knob-bg-color-default: #fff;
  --switch-primary-knob-bg-color-hover: #fff;
  --switch-primary-knob-bg-color-disabled: #fff;
  --switch-primary-knob-bg-color-checked-default: #fff;
  --switch-primary-knob-bg-color-checked-hover: #fff;
  --switch-primary-knob-bg-color-checked-disabled: #fff;
  --switch-primary-knob-border-color-default: rgba(255,255,255,0);
  --switch-primary-knob-border-color-hover: rgba(255,255,255,0);
  --switch-primary-knob-border-color-disabled: rgba(255,255,255,0);
  --switch-primary-knob-border-color-checked-default: rgba(255,255,255,0);
  --switch-primary-knob-border-color-checked-hover: rgba(255,255,255,0);
  --switch-primary-knob-border-color-checked-disabled: rgba(255,255,255,0);
  --switch-primary-knob-shadow-default: 0 0 1px 0 rgba(153, 153, 153, 0.1), 0 2px 2px 0 rgba(153, 153, 153, 0.2);
  --switch-primary-knob-shadow-hover: 0 0 1px 0 rgba(153, 153, 153, 0.1), 0 2px 2px 0 rgba(153, 153, 153, 0.2);
  --switch-primary-knob-shadow-disabled: 0 0 1px 0 rgba(153, 153, 153, 0.1), 0 2px 2px 0 rgba(153, 153, 153, 0.2);
  --switch-primary-knob-shadow-checked-default: 0 0 1px 0 rgba(153, 153, 153, 0.1), 0 2px 2px 0 rgba(153, 153, 153, 0.2);
  --switch-primary-knob-shadow-checked-hover: 0 0 1px 0 rgba(153, 153, 153, 0.1), 0 2px 2px 0 rgba(153, 153, 153, 0.2);
  --switch-primary-knob-shadow-checked-disabled: 0 0 1px 0 rgba(153, 153, 153, 0.1), 0 2px 2px 0 rgba(153, 153, 153, 0.2);
  --inputnumberstepper-l-height: 48px;
  --inputnumberstepper-l-border-width: 2px;
  --inputnumberstepper-l-button-border-width: 0;
  --inputnumberstepper-l-button-border-radius-inside: 0;
  --inputnumberstepper-l-button-border-radius-outside: 6px;
  --inputnumberstepper-l-hint-spacing: 8px;
  --inputnumberstepper-l-hint-font: 400 12px/16px var(--font-family);
  --inputnumberstepper-l-border-radius: 6px;
  --inputnumberstepper-l-inputvalue-font: 400 16px/24px var(--font-family);
  --inputnumberstepper-m-height: 36px;
  --inputnumberstepper-m-border-radius: 6px;
  --inputnumberstepper-m-button-border-radius-inside: 0;
  --inputnumberstepper-m-button-border-radius-outside: 6px;
  --inputnumberstepper-m-button-border-width: 0;
  --inputnumberstepper-m-border-width: 2px;
  --inputnumberstepper-m-inputvalue-font: 400 16px/24px var(--font-family);
  --inputnumberstepper-m-hint-font: 400 12px/16px var(--font-family);
  --inputnumberstepper-m-hint-spacing: 8px;
  --inputnumberstepper-primary-bg-color-default: ${COLORS.NEUTRAL.CONTAINER_DEFAULT};
  --inputnumberstepper-primary-bg-color-hover: rgba(255,255,255,0);
  --inputnumberstepper-primary-bg-color-focus: rgba(255,255,255,0);
  --inputnumberstepper-primary-bg-color-error: ${COLORS.NEUTRAL.CONTAINER_DEFAULT};
  --inputnumberstepper-primary-bg-color-disabled: rgba(153, 153, 153, 0.1);
  --inputnumberstepper-primary-border-color-default: rgba(153, 153, 153, 0);
  --inputnumberstepper-primary-border-color-hover: ${COLORS.ACCENT.DEFAULT};
  --inputnumberstepper-primary-border-color-focus: ${COLORS.ACCENT.DEFAULT};
  --inputnumberstepper-primary-border-color-error: rgba(153, 153, 153, 0);
  --inputnumberstepper-primary-border-color-disabled: rgba(255,255,255,0);
  --inputnumberstepper-primary-inputvalue-color-default: ${COLORS.FG.DEFAULT};
  --inputnumberstepper-primary-inputvalue-color-hover: ${COLORS.FG.DEFAULT};
  --inputnumberstepper-primary-inputvalue-color-focus: ${COLORS.FG.DEFAULT};
  --inputnumberstepper-primary-inputvalue-color-error: ${COLORS.FG.DEFAULT};
  --inputnumberstepper-primary-inputvalue-color-disabled: rgba(153, 153, 153, 0.5);
  --inputnumberstepper-primary-hint-color-default: #858fa3;
  --inputnumberstepper-primary-hint-color-hover: #858fa3;
  --inputnumberstepper-primary-hint-color-focus: #858fa3;
  --inputnumberstepper-primary-hint-color-error: #D91528;
  --inputnumberstepper-primary-hint-color-disabled: rgba(153, 153, 153, 0.5);
  --inputnumberstepper-primary-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --inputnumberstepper-primary-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --inputnumberstepper-primary-shadow-focus: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --inputnumberstepper-primary-shadow-error: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --inputnumberstepper-primary-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --inputnumberstepper-primary-button-shadow-default: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --inputnumberstepper-primary-button-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --inputnumberstepper-primary-button-shadow-active: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --inputnumberstepper-primary-button-shadow-disabled: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --inputnumberstepper-primary-button-bg-color-default: rgba(255,255,255,0);
  --inputnumberstepper-primary-button-bg-color-hover: rgba(153, 153, 153, 0.2);
  --inputnumberstepper-primary-button-bg-color-active: rgba(153, 153, 153, 0.3);
  --inputnumberstepper-primary-button-bg-color-disabled: rgba(255,255,255,0);
  --inputnumberstepper-primary-button-border-color-default: rgba(255,255,255,0);
  --inputnumberstepper-primary-button-border-color-hover: rgba(153, 153, 153, 0.2);
  --inputnumberstepper-primary-button-border-color-active: rgba(153, 153, 153, 0.3);
  --inputnumberstepper-primary-button-border-color-disabled: rgba(255,255,255,0);
  --inputnumberstepper-primary-button-icon-color-default: #999999;
  --inputnumberstepper-primary-button-icon-color-hover: #999999;
  --inputnumberstepper-primary-button-icon-color-active: #999999;
  --inputnumberstepper-primary-button-icon-color-disabled: rgba(153, 153, 153, 0.5);
  --inputnumberstepper-primary-button-icon-iconsingle-color: rgba(153, 153, 153, 0.5);
  --pickerdate-m-width: ${toRem(248)};
  --pickerdate-m-border-width: 0;
  --pickerdate-m-border-radius: 6px;
  --pickerdate-m-calendar-padding-vertical: 12px;
  --pickerdate-m-calendar-padding-horizontal: 14px;
  --pickerdate-m-calendar-digitdate-height: 36px;
  --pickerdate-m-calendar-date-border-width: 0;
  --pickerdate-m-calendar-date-border-radius: 6px;
  --pickerdate-m-calendar-date-font: 600 14px/20px var(--font-family);
  --pickerdate-m-calendar-textdate-height: 32px;
  --pickerdate-m-calendar-dayofweek-height: 16px;
  --pickerdate-m-calendar-dayofweek-font: 400 12px/16px var(--font-family);
  --pickerdate-m-calendar-height: 220px;
  --pickerdate-m-controlpanel-padding-horizontal: 12px;
  --pickerdate-m-controlpanel-height: 60px;
  --pickerdate-m-controlpanel-border-width: 0;
  --pickerdate-m-controlpanel-control-height: 32px;
  --pickerdate-m-controlpanel-control-border-radius: 6px;
  --pickerdate-m-controlpanel-control-border-width: 2px;
  --pickerdate-m-controlpanel-control-padding-horizontal: 8px;
  --pickerdate-m-controlpanel-month-font-default: 600 16px/24px var(--font-family);
  --pickerdate-m-controlpanel-month-font-hover: 600 16px/24px var(--font-family);
  --pickerdate-m-controlpanel-month-font-selected: 600 16px/24px var(--font-family);
  --pickerdate-m-controlpanel-year-font-default: 400 16px/24px var(--font-family);
  --pickerdate-m-controlpanel-year-font-hover: 600 16px/24px var(--font-family);
  --pickerdate-m-controlpanel-year-font-selected: 600 16px/24px var(--font-family);
  --pickerdate-m-controlpanel-fulldate-font: 600 16px/24px var(--font-family);
  --pickerdate-m-controlpanel-carouselcontrol-height: 36px;
  --pickerdate-m-controlpanel-carouselcontrol-border-width: 2px;
  --pickerdate-m-controlpanel-carouselcontrol-border-radius: 6px;
  --pickerdate-primary-bg-color: ${COLORS.BG.PAGE};
  --pickerdate-primary-border-color: rgba(255,255,255,0);
  --pickerdate-primary-shadow: none;
  --pickerdate-primary-calendar-date-bg-color-hover: rgba(153, 153, 153, 0.05);
  --pickerdate-primary-calendar-date-bg-color-selected: ${COLORS.ACCENT.DEFAULT};
  --pickerdate-primary-calendar-date-bg-color-selected-range: rgba(153, 153, 153, 0.1);
  --pickerdate-primary-calendar-date-bg-color-today: rgba(255,255,255,0);
  --pickerdate-primary-calendar-date-border-color-hover: rgba(255,255,255,0);
  --pickerdate-primary-calendar-date-border-color-selected: rgba(255,255,255,0);
  --pickerdate-primary-calendar-date-border-color-today: rgba(255,255,255,0);
  --pickerdate-primary-calendar-date-label-color-default: #999999;
  --pickerdate-primary-calendar-date-label-color-hover: #999999;
  --pickerdate-primary-calendar-date-label-color-selected: #fff;
  --pickerdate-primary-calendar-date-label-color-selected-range: #999999;
  --pickerdate-primary-calendar-date-label-color-today: ${COLORS.ACCENT.DEFAULT};
  --pickerdate-primary-calendar-date-label-color-disabled: rgba(153, 153, 153, 0.5);
  --pickerdate-primary-calendar-date-shadow-hover: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --pickerdate-primary-calendar-date-shadow-selected: inset 0 0 0 0 rgba(0, 0, 0, 0);
  --pickerdate-primary-calendar-dayofweek-label-color: #858fa3;
  --pickerdate-primary-controlpanel-bg-color: rgba(255,255,255,0);
  --pickerdate-primary-controlpanel-border-color: rgba(255,255,255,0);
  --pickerdate-primary-controlpanel-control-bg-color-default: rgba(255,255,255,0);
  --pickerdate-primary-controlpanel-control-bg-color-hover: rgba(153, 153, 153, 0.1);
  --pickerdate-primary-controlpanel-control-bg-color-selected: rgba(153, 153, 153, 0.1);
  --pickerdate-primary-controlpanel-control-border-color-default: rgba(255,255,255,0);
  --pickerdate-primary-controlpanel-control-border-color-hover: rgba(255,255,255,0);
  --pickerdate-primary-controlpanel-control-border-color-selected: rgba(255,255,255,0);
  --pickerdate-primary-controlpanel-month-label-color-default: ${COLORS.FG.DEFAULT};
  --pickerdate-primary-controlpanel-month-label-color-hover: ${COLORS.FG.DEFAULT};
  --pickerdate-primary-controlpanel-month-label-color-selected: ${COLORS.FG.DEFAULT};
  --pickerdate-primary-controlpanel-year-label-color-default: #858fa3;
  --pickerdate-primary-controlpanel-year-label-color-hover: ${COLORS.FG.DEFAULT};
  --pickerdate-primary-controlpanel-year-label-color-selected: ${COLORS.FG.DEFAULT};
  --pickerdate-primary-controlpanel-fulldate-label-color-selected: ${COLORS.FG.DEFAULT};
  --pickerdate-primary-controlpanel-carouselcontrol-bg-color-default: rgba(255,255,255,0);
  --pickerdate-primary-controlpanel-carouselcontrol-bg-color-hover: rgba(153, 153, 153, 0.1);
  --pickerdate-primary-controlpanel-carouselcontrol-border-color-default: rgba(255,255,255,0);
  --pickerdate-primary-controlpanel-carouselcontrol-border-color-hover: rgba(255,255,255,0);
  --pickerdate-primary-controlpanel-carouselcontrol-icon-color-default: ${COLORS.FG.DEFAULT};
  --pickerdate-primary-controlpanel-carouselcontrol-icon-color-hover: ${COLORS.FG.DEFAULT};
  --overlay-primary-color: rgba(153, 153, 153, 0.3);
  --overlay-secondary-color: rgba(153, 153, 153, 0.1);
  --focus-contrast-color: light-dark(transparent, transparent);
  --focus-contrast-extra-color: light-dark(transparent, transparent);
  --focus-contrast-border-width: 6px;
  --focus-contrast-extra-border-width: 2px;
  --focus-soft-color: var(--focus-soft);
  --focus-soft-border-width: 6px;

  --toastify-color-light: ${COLORS.BG.PAGE}
`;

export const ATOMARO_STYLES = `
  .input {
    width: 100%;
  }
  .input ~ .input__hint {
    width: 100%;
  }
  .popover__root {
    width: 100%;
    max-width: none;
  }

  .button {
    transition: all 0.3s ease 0s;

    &:active {
      transition: all 0.3s ease 0s, background-color 0s;
    }
  }

  .input .input__field {
    max-width: calc(100% - ${toRem(24)});
  }

  .input.input--size-m {
    margin-top: 0;
  }

  .input textarea.input__field {
    white-space: normal;
  }

  .popover_nopadding {
    &.popover.popover--size-m {
      padding: 0;
      border-radius: ${toRem(16)}
    }
  }

  .taggroup:has(.taggroup__inner:empty) {
    padding: 0 !important;
    margin: 0 !important;
  }

  .modal {
    padding: ${toRem(16)}
  }

  .modal__wrapper--hidden {
    pointer-events: none;
  }

  .ymaps3x0--zoom-control_vertical,
  .ymaps3x0--control-button {
    background-color: ${COLORS.ACCENT.DEFAULT};
    border-radius: ${toRem(8)}
  }

  .ymaps3x0--zoom-control__in {
    background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.25 12.75V18H12.75V12.75H18V11.25H12.75V6H11.25V11.25H6V12.75H11.25Z' fill='white'/%3E%3C/svg%3E%0A");
    &::before{
      content:'';
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      margin: 0 auto;
      height: ${toRem(1)};
      width: 50%;
      background-color: ${COLORS.STATIC.WHITE};
      z-index: 2;
    }
  }

  .ymaps3x0--zoom-control__out {
    background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M6 11.25H18V12.75H6V11.25Z' fill='white'/%3E%3C/svg%3E%0A");
  }

  .ymaps3x0--geolocation-control {
    background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.1141 12.895L12.744 19.4507C12.7819 19.6001 12.8661 19.7336 12.9846 19.8321C13.1031 19.9306 13.2498 19.9888 13.4035 19.9986C13.5572 20.0083 13.71 19.9689 13.8399 19.8862C13.9699 19.8034 14.0702 19.6815 14.1266 19.5381L19.9479 4.99909C20.0008 4.86672 20.0138 4.72171 19.9852 4.58203C19.9565 4.44236 19.8876 4.31416 19.7869 4.21334C19.6862 4.11252 19.5581 4.04351 19.4186 4.01486C19.279 3.98621 19.1342 3.99918 19.0019 4.05216L4.46147 9.86297C4.31814 9.91937 4.19638 10.0198 4.11371 10.1499C4.03105 10.28 3.99174 10.4329 4.00145 10.5868C4.01115 10.7407 4.06938 10.8875 4.16773 11.0061C4.26609 11.1247 4.39951 11.209 4.54879 11.2469L11.1141 12.895ZM7.22764 10.3729L11.4793 11.4401L12.3525 11.6593L12.5697 12.5331L13.6216 16.7637L17.8859 6.1135L7.22764 10.3729Z' fill='white'/%3E%3C/svg%3E%0A");
  }

  .modal__wrapper .overlay {
    max-height: 100dvh;
  }

  .modal.modal--centered.modal--scroll-behaviour {
    max-height: var(--modal-max-height, calc(100% - 112px));
    background-color: ${COLORS.BG.ELEVATED.M};
  }

  .tabs-item {
    flex-basis: auto;
    flex-grow: 0;
    padding: ${toRem(14)} ${toRem(12)};
  }

  .tabs-panel {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
  }

  ._orange {
    color: ${COLORS.ACCENT.DEFAULT}
  }
`;
